export interface ManufacturerColor {
  name: string;
  hex: string;
}

export interface MaterialColorSet {
  material: string;
  colors: ManufacturerColor[];
}

export interface ManufacturerCatalog {
  name: string;
  materials: MaterialColorSet[];
}

const ELEGOO: ManufacturerCatalog = {
  name: 'Elegoo',
  materials: [
    {
      material: 'PLA',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Space Grey', hex: '#5D5D5D' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Orange', hex: '#FD7C18' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Neon Green', hex: '#08E327' },
        { name: 'Sea Green', hex: '#1ABC83' },
        { name: 'Sky Blue', hex: '#27B2D0' },
        { name: 'Dark Blue', hex: '#2240AF' },
        { name: 'Purple', hex: '#603BA0' },
        { name: 'Pink', hex: '#F9B0BD' },
        { name: 'Brown', hex: '#9E6A4B' },
        { name: 'Beige', hex: '#FEE7BF' },
        { name: 'Translucent', hex: '#E9E9E7' },
        { name: 'Wood Color', hex: '#B19870' },
        { name: 'Copper Filled', hex: '#895837' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Space Grey', hex: '#5D5D5D' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Orange', hex: '#FD7C18' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Neon Green', hex: '#08E327' },
        { name: 'Sea Green', hex: '#1ABC83' },
        { name: 'Sky Blue', hex: '#27B2D0' },
        { name: 'Dark Blue', hex: '#2240AF' },
        { name: 'Purple', hex: '#603BA0' },
        { name: 'Pink', hex: '#F9B0BD' },
        { name: 'Brown', hex: '#9E6A4B' },
        { name: 'Beige', hex: '#FEE7BF' },
        { name: 'Translucent', hex: '#E9E9E7' },
        { name: 'Wood Color', hex: '#B19870' },
      ],
    },
    {
      material: 'Rapid PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Silver', hex: '#C0C0C0' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Orange', hex: '#FD7C18' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Green', hex: '#08E327' },
        { name: 'Blue', hex: '#2240AF' },
        { name: 'Brown', hex: '#9E6A4B' },
        { name: 'Beige', hex: '#FEE7BF' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Silver', hex: '#C0C0C0' },
        { name: 'True Red', hex: '#CC0000' },
        { name: 'Burgundy Red', hex: '#800020' },
        { name: 'Blue', hex: '#2240AF' },
        { name: 'Light Blue', hex: '#6CB4EE' },
        { name: 'Green', hex: '#228B22' },
        { name: 'Neon Green', hex: '#08E327' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Purple', hex: '#603BA0' },
        { name: 'Hot Pink', hex: '#FF69B4' },
        { name: 'Beige', hex: '#FEE7BF' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Matte Black', hex: '#1C1C1C' },
        { name: 'Matte White', hex: '#F0F0F0' },
        { name: 'Slate Grey', hex: '#708090' },
        { name: 'Ruby Red', hex: '#9B111E' },
        { name: 'Orange', hex: '#FD7C18' },
        { name: 'Sunshine Yellow', hex: '#FFDA03' },
        { name: 'Teal Green', hex: '#008080' },
        { name: 'Mint Green', hex: '#98FB98' },
        { name: 'Navy Blue', hex: '#001F5B' },
        { name: 'Ice Blue', hex: '#99CCEE' },
        { name: 'Lavender Purple', hex: '#B57EDC' },
        { name: 'Sakura Pink', hex: '#FFB7C5' },
        { name: 'Earth Brown', hex: '#7B5B3A' },
        { name: 'Beige', hex: '#E8D5B7' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Silk Gold', hex: '#E2AC00' },
        { name: 'Silk Silver Grey', hex: '#93969B' },
        { name: 'Silk Copper', hex: '#B87333' },
        { name: 'Silk White', hex: '#F5F5F0' },
        { name: 'Silk Red', hex: '#CC2233' },
        { name: 'Silk Coral Pink', hex: '#F88379' },
        { name: 'Silk Mint Green', hex: '#98FFB0' },
        { name: 'Silk Holly Green', hex: '#008000' },
        { name: 'Silk Sky Blue', hex: '#87CEEB' },
        { name: 'Silk Blue Green', hex: '#0D98BA' },
        { name: 'Silk Blue Purple', hex: '#6A5ACD' },
        { name: 'Silk Bluish Purple', hex: '#7B68EE' },
        { name: 'Silk Blue Magenta', hex: '#8B008B' },
        { name: 'Silk Black Red', hex: '#65516A' },
        { name: 'Silk Black Purple', hex: '#3D2B56' },
        { name: 'Silk Black Green', hex: '#2D5A27' },
        { name: 'Silk Green Red', hex: '#716C57' },
        { name: 'Silk Blue Green Orange', hex: '#2E8B57' },
        { name: 'Silk Blue Purple Black', hex: '#3B3178' },
        { name: 'Silk Yellow Purple', hex: '#9B59B6' },
      ],
    },
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Green', hex: '#228B22' },
        { name: 'Cyan', hex: '#00BFFF' },
        { name: 'Purple', hex: '#603BA0' },
        { name: 'Pink', hex: '#F9B0BD' },
        { name: 'Hot Pink', hex: '#FF69B4' },
        { name: 'Beige', hex: '#FEE7BF' },
        { name: 'Translucent', hex: '#E9E9E7' },
        { name: 'Sunflower Yellow', hex: '#FFDA03' },
        { name: 'Cobalt Blue', hex: '#0047AB' },
        { name: 'Apple Green', hex: '#8DB600' },
        { name: 'Turquoise Green', hex: '#00CED1' },
        { name: 'Cocoa Brown', hex: '#6B3A2A' },
        { name: 'Misty Blue', hex: '#7EB6D0' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Galaxy Purple', hex: '#3A2F6F' },
        { name: 'Galaxy Black', hex: '#1A1A2E' },
        { name: 'Galaxy Peacock Blue', hex: '#21606B' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Sparkle Black', hex: '#1A1A1A' },
        { name: 'Sparkle Gold', hex: '#DAA520' },
        { name: 'Sparkle Green', hex: '#2E8B57' },
        { name: 'Sparkle Red', hex: '#B22222' },
        { name: 'Sparkle Dark Grey', hex: '#4A4A4A' },
        { name: 'Sparkle Turquoise', hex: '#40E0D0' },
        { name: 'Sparkle Purplish Grey', hex: '#7A6B8A' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Marble', hex: '#E8E0D8' },
        { name: 'Marble Brick Red', hex: '#A04030' },
        { name: 'Marble Cement Grey', hex: '#B0AFA8' },
      ],
    },
    {
      material: 'PLA Glow',
      colors: [
        { name: 'Glow Blue', hex: '#00BFFF' },
        { name: 'Glow Green', hex: '#39FF14' },
        { name: 'Glow Yellow', hex: '#FFFF33' },
        { name: 'Glow Orange', hex: '#FF6600' },
        { name: 'Glow Pink', hex: '#FF69B4' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Silver', hex: '#C0C0C0' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Green', hex: '#228B22' },
        { name: 'Blue', hex: '#2240AF' },
        { name: 'Light Blue', hex: '#6CB4EE' },
        { name: 'Purple', hex: '#603BA0' },
        { name: 'Pink', hex: '#F9B0BD' },
        { name: 'Olive Green', hex: '#6B8E23' },
        { name: 'Burgundy Red', hex: '#800020' },
      ],
    },
    {
      material: 'Rapid PETG',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#8F949B' },
        { name: 'Space Grey', hex: '#5D5D5D' },
        { name: 'Red', hex: '#EA140E' },
        { name: 'Orange', hex: '#FD7C18' },
        { name: 'Yellow', hex: '#F6D701' },
        { name: 'Green', hex: '#08E327' },
        { name: 'Blue', hex: '#2240AF' },
        { name: 'Brown', hex: '#9E6A4B' },
        { name: 'Beige', hex: '#FEE7BF' },
        { name: 'Transparent', hex: '#F3F3F3' },
      ],
    },
  ],
};

const OVERTURE: ManufacturerCatalog = {
  name: 'Overture',
  materials: [
    {
      material: 'PLA',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Sparkle Black', hex: '#000000' },
        { name: 'Space Grey', hex: '#63646B' },
        { name: 'Cement Gray', hex: '#697272' },
        { name: 'Metallic Gray', hex: '#8B98AC' },
        { name: 'Royal Silver', hex: '#C6CDD2' },
        { name: 'Light Grey', hex: '#C7D4D6' },
        { name: 'White', hex: '#FFFEFA' },
        { name: 'Cold White', hex: '#FFFFFF' },
        { name: 'Wine', hex: '#BE133B' },
        { name: 'Fresh Red', hex: '#E31A1F' },
        { name: 'Red', hex: '#E9301E' },
        { name: 'Jeans Red', hex: '#FF706B' },
        { name: 'Pink', hex: '#F09BB5' },
        { name: 'Sakura Pink', hex: '#FFD1D1' },
        { name: 'Chocolate', hex: '#57361C' },
        { name: 'Brown', hex: '#D7A86A' },
        { name: 'Royal Copper', hex: '#A47456' },
        { name: 'Orange', hex: '#FF8E24' },
        { name: 'Yellow', hex: '#E6B535' },
        { name: 'Royal Gold', hex: '#FFCB47' },
        { name: 'Highlight Yellow', hex: '#E4FF33' },
        { name: 'Lemon Yellow', hex: '#FFED29' },
        { name: 'Light Yellow', hex: '#EFFF8A' },
        { name: 'Olive Green', hex: '#97A014' },
        { name: 'Green', hex: '#00C26B' },
        { name: 'Light Green', hex: '#8FFFA2' },
        { name: 'Glow In Dark (Green)', hex: '#EBF1E0' },
        { name: 'Morning Blue', hex: '#8FEEFF' },
        { name: 'Light Blue', hex: '#3ABBDE' },
        { name: 'Gray Blue', hex: '#81BAC1' },
        { name: 'Jeans Blue', hex: '#43729B' },
        { name: 'Blue', hex: '#033877' },
        { name: 'Purple', hex: '#6F4AB2' },
        { name: 'Sparkle Purple', hex: '#7701B2' },
      ],
    },
    {
      material: 'Matte PLA',
      colors: [
        { name: 'Carbon Fiber Black', hex: '#000000' },
        { name: 'Matte Black', hex: '#1D1E1E' },
        { name: 'Matte Light Grey', hex: '#BAC4C4' },
        { name: 'Matte Repose Gray', hex: '#B1A498' },
        { name: 'Matte White', hex: '#E6DEDE' },
        { name: 'Matte Brick Red', hex: '#D22D2F' },
        { name: 'Matte Red', hex: '#EB3B41' },
        { name: 'Matte Jeans Red', hex: '#F76E6E' },
        { name: 'Matte Pink', hex: '#FFE0E1' },
        { name: 'Matte Light Pink', hex: '#F7E6DE' },
        { name: 'Matte Baby Pink', hex: '#FFE0E0' },
        { name: 'Matte Chocolate', hex: '#503529' },
        { name: 'Matte Wood', hex: '#CAAC78' },
        { name: 'Matte Light Brown', hex: '#EDD5A6' },
        { name: 'Matte Light Blue', hex: '#99FFFA' },
        { name: 'Matte Blue', hex: '#005DA4' },
        { name: 'Matte Jeans Blue', hex: '#6787AD' },
        { name: 'Matte Dark Orange', hex: '#DC4116' },
        { name: 'Matte Orange', hex: '#F3C102' },
        { name: 'Matte Yellow', hex: '#EFDC4C' },
        { name: 'Matte Butter Yellow', hex: '#FCFAA6' },
        { name: 'Matte Light Orange', hex: '#F2B87B' },
        { name: 'Matte Skin', hex: '#F0DDC2' },
        { name: 'Matte Beige', hex: '#E7EFD7' },
        { name: 'Matte Olive Green', hex: '#A88704' },
        { name: 'Matte Grass Green', hex: '#CEFF5C' },
        { name: 'Matte Pale Green', hex: '#BECBA8' },
        { name: 'Matte Light Teal', hex: '#C7FFE3' },
        { name: 'Matte Light Green', hex: '#AFDEB9' },
        { name: 'Matte Bamboo Green', hex: '#A1D66B' },
        { name: 'Matte Turquoise', hex: '#60F0E7' },
        { name: 'Matte Green', hex: '#519F62' },
        { name: 'Matte Army Green', hex: '#6E8451' },
        { name: 'Matte Gray Green', hex: '#666F60' },
        { name: 'Matte Slate Gray', hex: '#4F6B86' },
        { name: 'Matte Navy Blue', hex: '#072E4E' },
        { name: 'Matte Lavender', hex: '#7E5777' },
        { name: 'Matte Purple', hex: '#8C69B5' },
        { name: 'Matte Lilac', hex: '#ECD1FF' },
        { name: 'Matte Black-White', hex: '#000000' },
        { name: 'Matte Orange-Red', hex: '#FCAB59' },
        { name: 'Matte Blue-Red', hex: '#0074BD' },
        { name: 'Light Blue-Yellow', hex: '#B8FFFF' },
      ],
    },
    {
      material: 'Rock PLA',
      colors: [
        { name: 'Rock White', hex: '#FFFFFF' },
        { name: 'Fossil Rock', hex: '#C2C0BA' },
        { name: 'Sedimentary Rock', hex: '#C4B199' },
        { name: 'Turquoise Green', hex: '#86DACD' },
        { name: 'Turquoise Blue', hex: '#A3EAFF' },
        { name: 'Mars Red', hex: '#D76D3B' },
        { name: 'Marigold Yellow', hex: '#FFDA47' },
        { name: 'Moonlight Gray', hex: '#E4E6E7' },
        { name: 'Mist Gray', hex: '#F2F3EC' },
        { name: 'Slate Gray', hex: '#638BA1' },
        { name: 'Haze Gray', hex: '#C3D2DA' },
        { name: 'Muted Gray', hex: '#CED2D4' },
      ],
    },
    {
      material: 'PLA Professional',
      colors: [
        { name: 'Black', hex: '#0D110E' },
        { name: 'Light Gray', hex: '#74777D' },
        { name: 'Space Grey', hex: '#969BA2' },
        { name: 'Silver Metal', hex: '#C9D0D4' },
        { name: 'White', hex: '#E8E4DF' },
        { name: 'Champagne', hex: '#F4F4EA' },
        { name: 'Wine', hex: '#800020' },
        { name: 'Fresh Red', hex: '#F00000' },
        { name: 'Red', hex: '#FF0505' },
        { name: 'Jeans Red', hex: '#CE4F4E' },
        { name: 'Pink', hex: '#F092B3' },
        { name: 'Sakura Pink', hex: '#FEC2C2' },
        { name: 'Chocolate', hex: '#50311E' },
        { name: 'Brown', hex: '#AB713E' },
        { name: 'Orange', hex: '#FF852E' },
        { name: 'Royal Gold', hex: '#E3B145' },
        { name: 'Yellow', hex: '#EEEA44' },
        { name: 'Light Yellow', hex: '#F4D563' },
        { name: 'Highlight Yellow', hex: '#EBFF57' },
        { name: 'Army Green', hex: '#8A8850' },
        { name: 'Green', hex: '#0CCF81' },
        { name: 'Light Green', hex: '#BCD69B' },
        { name: 'Olive Green', hex: '#B0BE50' },
        { name: 'Light Blue', hex: '#99F1FF' },
        { name: 'Gray Blue', hex: '#8FBBC1' },
        { name: 'Morning Blue', hex: '#75AFCD' },
        { name: 'Jeans Blue', hex: '#73A1BA' },
        { name: 'Digital Blue', hex: '#0099E6' },
        { name: 'Dark Blue', hex: '#003B80' },
        { name: 'Purple', hex: '#7659B5' },
        { name: 'Moonlight Silver', hex: '#D5DCDD' },
        { name: 'Bronze', hex: '#704515' },
        { name: 'Copper', hex: '#BB8330' },
      ],
    },
    {
      material: 'Super PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Light Gray', hex: '#BAC8C9' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#E60000' },
        { name: 'Pink', hex: '#FF5786' },
        { name: 'Sakura Pink', hex: '#FFCCCD' },
        { name: 'Light Brown', hex: '#B8AF99' },
        { name: 'Orange', hex: '#FF7A33' },
        { name: 'Yellow', hex: '#FFD342' },
        { name: 'Green', hex: '#00D17A' },
        { name: 'Dark Blue', hex: '#183681' },
        { name: 'Purple', hex: '#8761C1' },
      ],
    },
    {
      material: 'Easy PLA',
      colors: [
        { name: 'Easy Black', hex: '#000000' },
        { name: 'Easy Cement Grey', hex: '#697272' },
        { name: 'Easy Space Gray', hex: '#B2B8B8' },
        { name: 'Easy Rock White', hex: '#EDF0F2' },
        { name: 'Easy White', hex: '#FFFFFF' },
        { name: 'Easy Red', hex: '#FF2C29' },
        { name: 'Easy Orange', hex: '#FF5F2E' },
        { name: 'Easy Caramel', hex: '#A88D5D' },
        { name: 'Easy Digital Blue', hex: '#0696EF' },
        { name: 'Easy Green', hex: '#4DFF64' },
        { name: 'Glow Red', hex: '#FF7D7A' },
        { name: 'Glow Orange', hex: '#FF9C66' },
        { name: 'Glow Yellow', hex: '#EBFF6B' },
        { name: 'Glow Blue', hex: '#5EB7D4' },
        { name: 'Shimmer Silver Green', hex: '#9ECB86' },
        { name: 'Shimmer Bronze', hex: '#81BA6D' },
        { name: 'Shimmer Dark Green', hex: '#008059' },
        { name: 'Shimmer Purple', hex: '#906482' },
        { name: 'Easy Pink', hex: '#FFC0CB' },
        { name: 'Easy Yellow', hex: '#FCFF66' },
        { name: 'Easy Pumpkin Orange', hex: '#FF8D5C' },
        { name: 'Easy Beige', hex: '#F7F6ED' },
        { name: 'Easy Yolk Yellow', hex: '#FFE357' },
        { name: 'Easy Sky Blue', hex: '#3BC9ED' },
        { name: 'Easy Cobalt Blue', hex: '#274DA0' },
        { name: 'Easy Purple', hex: '#7B49A2' },
        { name: 'Easy Pine Green', hex: '#00A5A8' },
        { name: 'Easy Magenta', hex: '#FD3DB5' },
      ],
    },
    {
      material: 'Silk PLA',
      colors: [
        { name: 'Silk Gray', hex: '#394658' },
        { name: 'Silk Silver', hex: '#818FA0' },
        { name: 'Silk White', hex: '#DDD4CA' },
        { name: 'Silk Rose Red', hex: '#9B0350' },
        { name: 'Silk Fresh Red', hex: '#CC0201' },
        { name: 'Silk Red', hex: '#DA445A' },
        { name: 'Silk Silver Pink', hex: '#A8726B' },
        { name: 'Silk Christmas Red', hex: '#CE5D4C' },
        { name: 'Silk Pink', hex: '#DF877C' },
        { name: 'Silk Copper', hex: '#641501' },
        { name: 'Silk Neon Green', hex: '#91C800' },
        { name: 'Silk Green', hex: '#018E63' },
        { name: 'Silk Purple', hex: '#7769BC' },
        { name: 'Silk Blue', hex: '#0353BA' },
        { name: 'Silk Orange', hex: '#F44703' },
        { name: 'Silk Yellow', hex: '#ECC403' },
        { name: 'Silk Gold', hex: '#F9E352' },
        { name: 'Silk Gold-Silver', hex: '#B2C2C7' },
        { name: 'Silk Green-Silver', hex: '#00C28E' },
        { name: 'Silk Blue-Silver', hex: '#009DE0' },
        { name: 'Silk Blue-Yellow', hex: '#FFFF5C' },
        { name: 'Silk Green-Blue', hex: '#005AAD' },
        { name: 'Silk Purple-Gold', hex: '#702AB2' },
        { name: 'Silk Green-Magenta', hex: '#9FFF05' },
        { name: 'Silk Magenta-Gold', hex: '#B71A7D' },
        { name: 'Silk Red-Gold', hex: '#F04C64' },
      ],
    },
    {
      material: 'Air PLA',
      colors: [
        { name: 'Air Black', hex: '#000000' },
        { name: 'Air Light Gray', hex: '#AFAEAB' },
        { name: 'Air White', hex: '#EDD5B7' },
        { name: 'Air Orange', hex: '#FD9106' },
        { name: 'Air Wood', hex: '#E6C49E' },
        { name: 'Air Yellow', hex: '#F5C001' },
        { name: 'Air Neon Green', hex: '#C0D904' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Space Grey', hex: '#76797D' },
        { name: 'Light Gray', hex: '#D5D8DD' },
        { name: 'Rock White', hex: '#FFFFFF' },
        { name: 'White', hex: '#F5F5F4' },
        { name: 'Transparent Red', hex: '#CE333E' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Magenta', hex: '#C80181' },
        { name: 'Pink', hex: '#F79DBC' },
        { name: 'Orange', hex: '#FF854D' },
        { name: 'Gold', hex: '#CE8D00' },
        { name: 'Brown', hex: '#A47C48' },
        { name: 'Yellow', hex: '#FFC946' },
        { name: 'Grass Green', hex: '#C4D802' },
        { name: 'Green', hex: '#38AF69' },
        { name: 'Transparent Green', hex: '#019A45' },
        { name: 'Army Green', hex: '#404720' },
        { name: 'Digital Blue', hex: '#0378D0' },
        { name: 'Blue', hex: '#034E89' },
        { name: 'Transparent Blue', hex: '#09048E' },
        { name: 'Starry Blue', hex: '#142B4B' },
        { name: 'Sparkle Blue', hex: '#253F56' },
        { name: 'Purple', hex: '#7142A3' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Space Grey', hex: '#90999D' },
        { name: 'Grey', hex: '#E2E7E9' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#D7021C' },
        { name: 'Bright Pink', hex: '#FFBDD1' },
        { name: 'Orange', hex: '#FFA11D' },
        { name: 'Brown', hex: '#A47C48' },
        { name: 'Yellow', hex: '#FFDF03' },
        { name: 'Green', hex: '#00EB75' },
        { name: 'Digital Blue', hex: '#0378D0' },
        { name: 'Blue', hex: '#274E96' },
        { name: 'Purple', hex: '#8B69CE' },
        { name: 'Neon Green', hex: '#2EFF6D' },
        { name: 'Neon Orange', hex: '#FA8E36' },
        { name: 'Neon Red', hex: '#FF3F38' },
        { name: 'Light Green', hex: '#A0FD62' },
      ],
    },
    {
      material: 'High Speed TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#CDCFD5' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Pink', hex: '#FFA3C6' },
        { name: 'Translucent Red', hex: '#C00000' },
        { name: 'Translucent Blue', hex: '#386DFF' },
        { name: 'Translucent Orange', hex: '#FA4616' },
        { name: 'Translucent Purple', hex: '#8014C8' },
        { name: 'Translucent Green', hex: '#00E691' },
        { name: 'Orange', hex: '#FF8B47' },
        { name: 'Grass Green', hex: '#B1FF0A' },
        { name: 'Neon Magenta', hex: '#FB23AF' },
        { name: 'Neon Yellow', hex: '#FEF71D' },
        { name: 'Pastel Rose', hex: '#F5D0B7' },
        { name: 'Luminous Pink', hex: '#DCDCE4' },
        { name: 'Luminous Electric Indigo', hex: '#C3D3E0' },
        { name: 'Luminous Blue', hex: '#E9E7E7' },
        { name: 'Luminous Orange', hex: '#E8E8E8' },
        { name: 'Luminous Green', hex: '#ECF2E9' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Ash Grey', hex: '#6C7074' },
        { name: 'Diamond Gray', hex: '#8C8C8C' },
        { name: 'Slate Gray', hex: '#91A0B6' },
        { name: 'Gray', hex: '#CACAC9' },
        { name: 'Natural', hex: '#F8F8EE' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Dark Red', hex: '#FF311F' },
        { name: 'Pink', hex: '#F79DBC' },
        { name: 'Orange', hex: '#FF6229' },
        { name: 'Diamond Orange', hex: '#FF8133' },
        { name: 'Royal Gold', hex: '#F0A400' },
        { name: 'Gold', hex: '#FFDA05' },
        { name: 'Yellow', hex: '#FFFF47' },
        { name: 'Grass Green', hex: '#C4D802' },
        { name: 'Green', hex: '#3D9441' },
        { name: 'Glow Green', hex: '#EBEFEE' },
        { name: 'Dark Green', hex: '#008F77' },
        { name: 'Light Blue', hex: '#5DC5EA' },
        { name: 'Blue', hex: '#00628F' },
        { name: 'Dark Blue', hex: '#034E89' },
        { name: 'Purple', hex: '#7142A3' },
        { name: 'Diamond Purple', hex: '#A04ED0' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#B5B9BA' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#AF251E' },
        { name: 'Diamond Red', hex: '#C01616' },
        { name: 'Brown', hex: '#785F53' },
        { name: 'Orange', hex: '#FF9A40' },
        { name: 'Yellow', hex: '#FFE802' },
        { name: 'Natural', hex: '#F1E6B3' },
        { name: 'Olive Green', hex: '#6B7550' },
        { name: 'Diamond Green', hex: '#26A648' },
        { name: 'Green', hex: '#01AA5E' },
        { name: 'Diamond Blue', hex: '#324485' },
        { name: 'Blue', hex: '#002979' },
        { name: 'Purple', hex: '#7959B6' },
      ],
    },
    {
      material: 'Easy Nylon',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#808E93' },
      ],
    },
    {
      material: 'PC Professional',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#E3E8E7' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#D7021C' },
        { name: 'Blue', hex: '#0378D0' },
      ],
    },
  ],
};

const HATCHBOX: ManufacturerCatalog = {
  name: 'Hatchbox',
  materials: [
    {
      material: 'PLA',
      colors: [
        { name: 'Black', hex: '#2A2A2A' },
        { name: 'White', hex: '#E3E5E5' },
        { name: 'Red', hex: '#AE3129' },
        { name: 'Blue', hex: '#06479B' },
        { name: 'Green', hex: '#0D9748' },
        { name: 'Yellow', hex: '#F4E210' },
        { name: 'Orange', hex: '#D65E16' },
        { name: 'Silver', hex: '#8E8D93' },
        { name: 'Pink', hex: '#D76293' },
        { name: 'Purple', hex: '#5B2C8A' },
        { name: 'Light Blue', hex: '#5BABD6' },
        { name: 'Cool Gray', hex: '#959493' },
        { name: 'Gold', hex: '#C5A94C' },
        { name: 'Copper', hex: '#936F48' },
        { name: 'Bronze', hex: '#8E734F' },
        { name: 'Brown', hex: '#452923' },
        { name: 'Iron Red', hex: '#79111E' },
        { name: 'Midnight Purple', hex: '#2E1A47' },
        { name: 'Mint Green', hex: '#98D9C2' },
        { name: 'Forest Green', hex: '#1B5E32' },
        { name: 'Peacock Blue', hex: '#006B7F' },
        { name: 'Beige', hex: '#D4C5A9' },
        { name: 'Natural', hex: '#B6BAB0' },
        { name: 'Gray Blue', hex: '#6B7F99' },
        { name: 'Dark Yellow', hex: '#D4A017' },
        { name: 'Baby Blue', hex: '#89CFF0' },
        { name: 'Lime Green', hex: '#76C843' },
        { name: 'Neon Green', hex: '#39FF14' },
        { name: 'Light Purple', hex: '#B19CD9' },
        { name: 'Light Orange', hex: '#F4A460' },
        { name: 'Pastel Green', hex: '#A8D8B9' },
        { name: 'Rose Gold', hex: '#B76E79' },
        { name: 'Glow in the Dark', hex: '#E8F5E1' },
        { name: 'Carbon Fiber', hex: '#3A3A3A' },
        { name: 'Wood', hex: '#A4856C' },
        { name: 'Granite', hex: '#D0CFD1' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Black Matte', hex: '#2D2D2D' },
        { name: 'White Matte', hex: '#DEDEDE' },
        { name: 'Navy Matte', hex: '#1E3A5F' },
        { name: 'Ash Gray Matte', hex: '#B0AFA8' },
        { name: 'Olive Matte', hex: '#6B7B3A' },
        { name: 'Brown Matte', hex: '#5C3A28' },
        { name: 'Gray Matte', hex: '#808080' },
        { name: 'Kraft Matte', hex: '#B5906B' },
        { name: 'Stone Gray Matte', hex: '#8A8D8F' },
        { name: 'Orange Matte', hex: '#D06B2D' },
        { name: 'Cherry Red Matte', hex: '#9B1B30' },
        { name: 'Terracotta Matte', hex: '#C45A3C' },
        { name: 'Baby Pink Matte', hex: '#F4C2C2' },
        { name: 'Light Lavender Matte', hex: '#C4A8D8' },
        { name: 'Blush Pink Matte', hex: '#DE9FAB' },
        { name: 'Lemon Yellow Matte', hex: '#FFF44F' },
        { name: 'Dusty Plum Matte', hex: '#7A5C6A' },
        { name: 'Butter Yellow Matte', hex: '#F5E6A3' },
        { name: 'Cool Mint Matte', hex: '#8FD8C8' },
        { name: 'Topaz Green Matte', hex: '#3B8868' },
        { name: 'Brick Red Matte', hex: '#8B3A3A' },
        { name: 'Salmon Pink Matte', hex: '#FA8072' },
        { name: 'Guacamole Green Matte', hex: '#7A9B57' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Silk Gold', hex: '#C58C3F' },
        { name: 'Silk Silver', hex: '#C0C0C0' },
        { name: 'Silk Pink', hex: '#E8A0BF' },
        { name: 'Silk Mint', hex: '#A0D6C8' },
        { name: 'Silk White', hex: '#F0EDE8' },
        { name: 'Silk Light Blue', hex: '#A3C9E8' },
        { name: 'Silk Brown', hex: '#8B6C4A' },
      ],
    },
    {
      material: 'PLA Metallic',
      colors: [
        { name: 'Metallic Black', hex: '#2C2C30' },
        { name: 'Metallic Gray', hex: '#6E6E72' },
        { name: 'Metallic Gold', hex: '#B8962E' },
        { name: 'Metallic Copper', hex: '#A86A3D' },
        { name: 'Metallic Blue', hex: '#2B5597' },
        { name: 'Metallic Red', hex: '#8B2A2A' },
        { name: 'Metallic Purple', hex: '#5C3180' },
        { name: 'Metallic Green', hex: '#2D6E3F' },
        { name: 'Metallic Bronze', hex: '#7A6340' },
        { name: 'Metallic White', hex: '#D8D8DC' },
        { name: 'Metallic Neon Green', hex: '#39B54A' },
        { name: 'Metallic Pink', hex: '#C75B8A' },
        { name: 'Metallic Light Blue', hex: '#6AA4C8' },
        { name: 'Metallic Rust', hex: '#8B4513' },
        { name: 'Metallic Yellow', hex: '#C5A829' },
        { name: 'Metallic Orange', hex: '#C0601F' },
        { name: 'Metallic Beige', hex: '#C4B08E' },
      ],
    },
    {
      material: 'PLA PRO+',
      colors: [
        { name: 'Black', hex: '#2A2A2A' },
        { name: 'White', hex: '#E3E5E5' },
        { name: 'Red', hex: '#AE3129' },
        { name: 'Blue', hex: '#06479B' },
        { name: 'Green', hex: '#0D9748' },
        { name: 'Yellow', hex: '#F4E210' },
        { name: 'Orange', hex: '#D65E16' },
        { name: 'Silver', hex: '#8E8D93' },
        { name: 'Iron Red', hex: '#79111E' },
        { name: 'Cool Gray', hex: '#959493' },
        { name: 'Midnight Purple', hex: '#2E1A47' },
        { name: 'Forest Green', hex: '#1B5E32' },
        { name: 'Gray Blue', hex: '#6B7F99' },
        { name: 'Brown', hex: '#452923' },
        { name: 'Light Blue', hex: '#5BABD6' },
        { name: 'Peacock Blue', hex: '#006B7F' },
        { name: 'Dark Yellow', hex: '#D4A017' },
        { name: 'Baby Blue', hex: '#89CFF0' },
        { name: 'Purple', hex: '#5B2C8A' },
        { name: 'Beige', hex: '#D4C5A9' },
        { name: 'Lime Green', hex: '#76C843' },
        { name: 'Neon Green', hex: '#39FF14' },
        { name: 'Copper', hex: '#936F48' },
        { name: 'Pink', hex: '#D76293' },
        { name: 'Light Purple', hex: '#B19CD9' },
        { name: 'Light Orange', hex: '#F4A460' },
        { name: 'Mint', hex: '#98D9C2' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Black', hex: '#282A27' },
        { name: 'White', hex: '#F1F3FC' },
        { name: 'Red', hex: '#AE3129' },
        { name: 'Blue', hex: '#06479B' },
        { name: 'Green', hex: '#008F3D' },
        { name: 'Orange', hex: '#D65E16' },
        { name: 'Silver', hex: '#8E8D93' },
        { name: 'Natural', hex: '#D8D8D0' },
        { name: 'Transparent White', hex: '#E8E8E8' },
        { name: 'Gray Blue', hex: '#6B7F99' },
        { name: 'Lake Blue', hex: '#0868B7' },
        { name: 'Midnight Purple', hex: '#2E1A47' },
        { name: 'Dark Green', hex: '#0B5D2E' },
        { name: 'Copper', hex: '#936F48' },
        { name: 'Peacock Blue', hex: '#006B7F' },
        { name: 'Bronze', hex: '#8E734F' },
        { name: 'Lime Green', hex: '#76C843' },
        { name: 'Gold', hex: '#C5A94C' },
        { name: 'Purple', hex: '#5B2C8A' },
        { name: 'Pink', hex: '#D76293' },
        { name: 'Baby Blue', hex: '#89CFF0' },
        { name: 'Brown', hex: '#452923' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Black', hex: '#2A2A2A' },
        { name: 'White', hex: '#E3E5E5' },
        { name: 'Red', hex: '#DD2820' },
        { name: 'Blue', hex: '#0A4C94' },
        { name: 'Green', hex: '#0C8D42' },
        { name: 'Yellow', hex: '#F4E210' },
        { name: 'Orange', hex: '#D65E16' },
        { name: 'Purple', hex: '#5B2C8A' },
        { name: 'Pink', hex: '#D76293' },
        { name: 'Light Blue', hex: '#5BABD6' },
        { name: 'Gold', hex: '#C5A94C' },
        { name: 'Copper', hex: '#936F48' },
        { name: 'Bronze', hex: '#8E734F' },
        { name: 'Brown', hex: '#452923' },
        { name: 'Beige', hex: '#D4C5A9' },
        { name: 'Neon Green', hex: '#39FF14' },
        { name: 'Glow in the Dark', hex: '#F6F5F2' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#2A2A2A' },
        { name: 'White', hex: '#E3E5E5' },
        { name: 'Red', hex: '#AE3129' },
        { name: 'Blue', hex: '#06479B' },
        { name: 'Green', hex: '#0D9748' },
        { name: 'Yellow', hex: '#F4E210' },
        { name: 'Orange', hex: '#D65E16' },
        { name: 'Silver', hex: '#8E8D93' },
        { name: 'Purple', hex: '#5B2C8A' },
        { name: 'Pink', hex: '#D76293' },
        { name: 'Iron Red', hex: '#79111E' },
        { name: 'Light Blue', hex: '#5BABD6' },
        { name: 'Cool Gray', hex: '#959493' },
        { name: 'Baby Blue', hex: '#89CFF0' },
        { name: 'Lime Green', hex: '#76C843' },
        { name: 'Neon Green', hex: '#39FF14' },
        { name: 'Beige', hex: '#D4C5A9' },
        { name: 'Mint Green', hex: '#98D9C2' },
      ],
    },
  ],
};

const _3DHOJOR: ManufacturerCatalog = {
  name: '3DHoJor',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Yellow', hex: '#FBFC00' },
        { name: 'White', hex: '#FFFEFE' },
        { name: 'Silver', hex: '#B1B0AE' },
        { name: 'Periwinkle Blue', hex: '#6064C7' },
        { name: 'Blood Orange', hex: '#F08000' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Silver', hex: '#D9D9D9' },
        { name: 'Light Blue', hex: '#03AFD5' },
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Cool White', hex: '#FFFFFF' },
        { name: 'Space Blue', hex: '#86D7FE' },
        { name: 'Baby Pink', hex: '#FAB4BF' },
        { name: 'Coral Orange', hex: '#FF7500' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Cyan Blue', hex: '#55ECD5' },
        { name: 'Yellow', hex: '#F8EBAD' },
        { name: 'Dark Blue', hex: '#151F29' },
        { name: 'Orange', hex: '#F79234' },
        { name: 'Milky White', hex: '#CEF5EF' },
        { name: 'Fire Engine Red', hex: '#D12B2B' },
        { name: 'Blue Purple Green', hex: '#70BAE1' },
        { name: 'Lilac', hex: '#DCD0FF' },
        { name: 'Matcha Green', hex: '#BCC99B' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Silver', hex: '#CDC9D2' },
        { name: 'Copper', hex: '#CC7349' },
        { name: 'Black Green', hex: '#1D4131' },
        { name: 'Blue/Orange/Green', hex: '#00FF00' },
        { name: 'Tulip', hex: '#96D35F' },
        { name: 'Purple Green', hex: '#228533' },
        { name: 'Black/Red', hex: '#B51A00' },
        { name: 'Blue', hex: '#0937ED' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Red', hex: '#F10909' },
        { name: 'Green', hex: '#96D35F' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Green', hex: '#76BB40' },
        { name: 'Orange', hex: '#FF8040' },
      ],
    },
  ],
};

const ANYCUBIC: ManufacturerCatalog = {
  name: 'Anycubic',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Strawberry Pink', hex: '#FE878F' },
        { name: 'Wooden', hex: '#624422' },
        { name: 'Peach Fuzz', hex: '#FF8C82' },
        { name: 'Bright Yellow', hex: '#FDDB27' },
        { name: 'Texture Grey', hex: '#75787B' },
        { name: 'Vibrant Orange', hex: '#FF7338' },
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#B1B3B3' },
        { name: 'Vibrant Yellow', hex: '#F3E500' },
        { name: 'Bright Red', hex: '#E10600' },
        { name: 'Blue', hex: '#247CDB' },
        { name: 'Purple Opulence', hex: '#695FA1' },
        { name: 'Clear', hex: '#F0F2F5' },
        { name: 'Bright White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Yellow', hex: '#F3E500' },
        { name: 'Purple', hex: '#6A6DCD' },
        { name: 'Pink', hex: '#FF8DA1' },
        { name: 'Orange', hex: '#FF7F32' },
        { name: 'Green Flash', hex: '#75CB5D' },
        { name: 'Purple Opulence', hex: '#6424FF' },
        { name: 'Vibrant Yellow', hex: '#F3E500' },
        { name: 'Brown', hex: '#927968' },
        { name: 'Peach Pink', hex: '#FF8E6E' },
        { name: 'Interstellar Violet', hex: '#7B69FF' },
        { name: 'Beige', hex: '#D4B996' },
        { name: 'Pearl Black', hex: '#212721' },
        { name: 'Spring Leaf', hex: '#8DFF8D' },
        { name: 'Tropical Turquoise', hex: '#16B2FF' },
        { name: 'Texture Grey', hex: '#75787B' },
        { name: 'Light Blue', hex: '#74D1EA' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Mtte Mint', hex: '#86C8BC' },
        { name: 'Matte Blue', hex: '#1366A0' },
        { name: 'Red-Blue', hex: '#BA0C2F' },
        { name: 'Red Blue', hex: '#FF0000' },
        { name: 'Matte Red', hex: '#DE4343' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Black Green', hex: '#000000' },
        { name: 'Pink Gold', hex: '#F67599' },
        { name: 'Copper', hex: '#AF5C37' },
        { name: 'Green', hex: '#52D2BC' },
        { name: 'Grey', hex: '#626262' },
        { name: 'Christmas Green', hex: '#008755' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Metal Blue', hex: '#3177A3' },
        { name: 'Orange Blue Green', hex: '#E78D0D' },
        { name: 'Black Gold', hex: '#000000' },
        { name: 'Black Blue', hex: '#000000' },
        { name: 'Red Yellow Blue', hex: '#C8102E' },
        { name: 'Blue Green', hex: '#003594' },
        { name: 'Black Gold Purple', hex: '#000000' },
        { name: 'Shiny Gold', hex: '#F2A900' },
        { name: 'Gold', hex: '#D19000' },
        { name: 'Pink / Gold', hex: '#EF60A3' },
        { name: 'Metal Champagne', hex: '#B59C70' },
        { name: 'Metal Copper', hex: '#956C58' },
        { name: 'Metal Black', hex: '#43403D' },
        { name: 'Rainbow 01', hex: '#B669FF' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Marble White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Green', hex: '#2CC84D' },
        { name: 'Blue', hex: '#00AFD7' },
        { name: 'White (Green Glow)', hex: '#D7D9D2' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Texture Silver', hex: '#8A8D8F' },
        { name: 'Cream', hex: '#F9DFB9' },
        { name: 'Purple', hex: '#6A6DCD' },
        { name: 'Orange', hex: '#FF7B00' },
        { name: 'Green', hex: '#009639' },
        { name: 'Forest Green', hex: '#43523B' },
        { name: 'Beige', hex: '#D4B996' },
        { name: 'Pink', hex: '#FB637E' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Lime Green', hex: '#78D64B' },
        { name: 'Brown', hex: '#927968' },
        { name: 'Lake Blue', hex: '#0084D4' },
        { name: 'Dark Grey', hex: '#7E868A' },
        { name: 'Peanut Brown', hex: '#A9754F' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Grey', hex: '#4D4D4D' },
        { name: 'Translucent Clear', hex: '#EFF0F1' },
        { name: 'Pink', hex: '#F8C1B8' },
        { name: 'Brown', hex: '#CDA077' },
        { name: 'Olive', hex: '#78874D' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#0000FF' },
        { name: 'Red', hex: '#B90000' },
        { name: 'Grey', hex: '#808080' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Black', hex: '#212721' },
        { name: 'Grey', hex: '#8A8D8F' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Orange', hex: '#FFAE00' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Grey', hex: '#63666A' },
        { name: 'Clear', hex: '#FFFFFF' },
        { name: 'Clear Orange', hex: '#FF6A00' },
        { name: 'Clear Red', hex: '#E32400' },
        { name: 'Clear Purple', hex: '#A438A8' },
      ],
    },
  ],
};

const BAMBU_LAB: ManufacturerCatalog = {
  name: 'Bambu Lab',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: '/Dark Grey', hex: '#6F6E6D' },
        { name: 'Cocoa Brown', hex: '#6F5034' },
        { name: '/Red', hex: '#D23738' },
        { name: '/Black', hex: '#000000' },
        { name: 'Maroon Red', hex: '#9D2235' },
        { name: '/Orange Yellow', hex: '#F47920' },
        { name: 'Black', hex: '#000000' },
        { name: '/Beige', hex: '#F7E6DE' },
        { name: 'Bronze', hex: '#847D48' },
        { name: 'Pink', hex: '#F55A74' },
        { name: 'Red', hex: '#FF0000' },
        { name: '/White', hex: '#FFFEF7' },
        { name: '/Gray', hex: '#9FA19F' },
        { name: 'Sunflower Yellow', hex: '#FFB549' },
        { name: 'Cyan', hex: '#00FFFF' },
        { name: 'Beige', hex: '#F7E6DE' },
        { name: 'Indigo Purple', hex: '#482960' },
        { name: 'Gold', hex: '#E4BD68' },
        { name: 'Blue (10600) (Old)', hex: '#0A2989' },
        { name: 'Cobalt Blue', hex: '#0056B8' },
        { name: 'Magenta', hex: '#EC008C' },
        { name: 'Arctic Whisper', hex: '#A4BFDA' },
        { name: 'Light Gray', hex: '#D1D3D5' },
        { name: 'Yellow', hex: '#FFD834' },
        { name: 'Green', hex: '#00BB31' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Gray', hex: '#9FA19F' },
        { name: 'Blue', hex: '#004EA8' },
        { name: 'Mistletoe Green', hex: '#3F8E43' },
        { name: 'Purple', hex: '#5E43B7' },
        { name: 'Orange', hex: '#FF671F' },
        { name: 'Dark Gray', hex: '#6F6E6D' },
        { name: 'Lithophane Bundle', hex: '#00FFFF' },
        { name: 'Bambu Green (Old)', hex: '#00AE42' },
        { name: 'Brown', hex: '#9D432C' },
        { name: 'Silver', hex: '#A6A9AA' },
        { name: 'Jade White', hex: '#FFFFFF' },
        { name: 'Hot Pink', hex: '#F5547C' },
        { name: 'Pumpkin Orange', hex: '#FF9016' },
        { name: 'Blue Gray', hex: '#5B6579' },
        { name: 'Bright Green', hex: '#BECF00' },
        { name: 'Bambu Green', hex: '#00AE42' },
        { name: 'Teal', hex: '#009FA1' },
        { name: 'Ice Blue', hex: '#B8CDE9' },
        { name: 'Cherry Pink', hex: '#F5B6CD' },
        { name: 'Olive', hex: '#AFC4A3' },
        { name: 'Solar Breeze', hex: '#FC776A' },
        { name: 'Light Jade', hex: '#96D8AF' },
        { name: 'Ocean to Meadow', hex: '#307FE2' },
        { name: 'Lavender', hex: '#B8ACD6' },
        { name: 'Mint Lime', hex: '#4EC83A' },
        { name: 'Blueberry Bubblegum', hex: '#6FCAEF' },
        { name: 'Pink Citrus', hex: '#E4555E' },
        { name: 'Mellow Yellow', hex: '#F5DBAB' },
        { name: 'Cotton Candy Cloud', hex: '#E7C1D5' },
        { name: 'Dusk Glare', hex: '#ED6022' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Orange', hex: '#DC3A27' },
        { name: 'Silver', hex: '#959698' },
        { name: 'Gray 12105', hex: '#ADADAD' },
        { name: 'Tough+', hex: '#515252' },
        { name: 'White', hex: '#FCFCFC' },
        { name: 'Yellow', hex: '#F4D53F' },
        { name: 'Grey', hex: '#AFB1AE' },
        { name: 'Cyan', hex: '#009BD8' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Gray', hex: '#515A6C' },
        { name: 'Lavender-Blue', hex: '#6667AB' },
        { name: 'Vermilion-Red', hex: '#DD3C22' },
        { name: 'Light-Blue', hex: '#0085AD' },
        { name: 'Yellow', hex: '#FEDB00' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Orange', hex: '#FF7F41' },
        { name: 'Pine Green', hex: '#00482B' },
        { name: 'Cream White', hex: '#FAFAFA' },
        { name: 'Black', hex: '#000000' },
        { name: 'Grey', hex: '#ADADAD' },
        { name: 'Silver', hex: '#959698' },
        { name: 'Cyan', hex: '#019BD9' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Caramel', hex: '#AE835B' },
        { name: 'Apple Green', hex: '#C2E189' },
        { name: 'Lime green', hex: '#6EE53C' },
        { name: 'Plum', hex: '#950051' },
        { name: 'Scarlet Red', hex: '#DE4343' },
        { name: 'Desert Tan', hex: '#E8DBB7' },
        { name: 'Nardo Gray', hex: '#757575' },
        { name: 'Sky Blue', hex: '#56B7E6' },
        { name: 'Terracotta', hex: '#B15533' },
        { name: 'Dark Brown', hex: '#7D6556' },
        { name: 'Sunflower Yellow', hex: '#F5C929' },
        { name: 'Dark Chocolate', hex: '#4D3324' },
        { name: 'Ice Blue', hex: '#A3D8E1' },
        { name: 'Tangerine Orange', hex: '#CC6F3E' },
        { name: 'Lemon Yellow', hex: '#F7D959' },
        { name: 'Lilac purple', hex: '#AE96D4' },
        { name: 'Dark Green', hex: '#68724D' },
        { name: 'Grass Green', hex: '#61C680' },
        { name: 'Latte Brown', hex: '#D3B7A7' },
        { name: 'Ivory White', hex: '#FFFFFF' },
        { name: 'Charcoal', hex: '#000000' },
        { name: 'Ash Gray', hex: '#9B9EA0' },
        { name: 'White', hex: '#F5F5F5' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Titan Gray', hex: '#5F6367' },
        { name: 'Silver', hex: '#B8B8B8' },
        { name: 'Midnight Blaze - Blue Red', hex: '#2C1376' },
        { name: 'Dawn Radiance', hex: '#FFA57D' },
        { name: 'Gold', hex: '#F4A925' },
        { name: 'Purple', hex: '#8671CB' },
        { name: 'Green', hex: '#00B80C' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Pink', hex: '#EEB1C1' },
        { name: 'Neon City (Blue-Magenta)', hex: '#0047BB' },
        { name: 'Rose Gold', hex: '#BA9594' },
        { name: 'Grey', hex: '#7D7D7D' },
        { name: 'Candy Green', hex: '#018814' },
        { name: 'Neon City', hex: '#0047BB' },
        { name: 'Gilded Rose (Pink-Gold)', hex: '#FF9425' },
        { name: 'Cobalt Blue Metallic', hex: '#39699E' },
        { name: 'Blue', hex: '#008BDA' },
        { name: 'South Beach', hex: '#F772A4' },
        { name: 'Candy Red', hex: '#D02727' },
        { name: 'Midnight Blaze (Blue-Red)', hex: '#0047BB' },
        { name: 'Velvet Eclipse', hex: '#000000' },
        { name: 'Iron Gray Metallic', hex: '#43403D' },
        { name: 'Black', hex: '#000000' },
        { name: 'Iridium Gold Metallic', hex: '#B39B84' },
        { name: 'Mystic Magenta', hex: '#720062' },
        { name: 'Aurora Purple 13909', hex: '#7F3696' },
        { name: 'Champagne', hex: '#F3CFB2' },
        { name: 'Aurora Purple', hex: '#7F3696' },
        { name: 'Blue Hawaii (Blue-Green)', hex: '#60A4E8' },
        { name: 'Phantom Blue (Blue-Black)', hex: '#000000' },
        { name: 'Mint', hex: '#96DCB9' },
        { name: 'Baby Blue', hex: '#A8C6EE' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Copper', hex: '#5E4B3C' },
        { name: 'Midnight Blaze', hex: '#0047BB' },
        { name: 'Copper Brown Metallic', hex: '#AA6443' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Onyx Black Sparkle', hex: '#2D2B28' },
        { name: 'Crimson Red Sparkle', hex: '#792B36' },
        { name: 'Alpine Green Sparkle', hex: '#3F5443' },
        { name: 'Black', hex: '#000000' },
        { name: 'Onyx Back Sparkle', hex: '#2D2B28' },
        { name: 'Classic Gold', hex: '#CEA629' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Nebula', hex: '#424379' },
        { name: 'Brown', hex: '#684A43' },
        { name: 'Green', hex: '#3B665E' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'White Marble', hex: '#F7F3F0' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Rosewood', hex: '#735757' },
        { name: 'White Oak', hex: '#D6CCA3' },
        { name: 'Clay Brown', hex: '#995F11' },
        { name: 'Ochre Yellow', hex: '#C98935' },
        { name: 'Black Walnut', hex: '#4F3F24' },
        { name: 'Classic Birch', hex: '#918669' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Glow Green', hex: '#24F626' },
        { name: 'Glow Blue', hex: '#7AC0E9' },
        { name: 'Glow Yellow', hex: '#F8FF80' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Jeans Blue', hex: '#6E88BC' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Purple', hex: '#9E007E' },
        { name: 'Transparent', hex: '#FFFFFF' },
        { name: 'Lime Green', hex: '#6EE53C' },
        { name: 'Gray', hex: '#ADB1B2' },
        { name: 'Forrest Green', hex: '#39541A' },
        { name: 'Red', hex: '#D6001C' },
        { name: 'Natural', hex: '#FFE2D6' },
        { name: 'Yellow', hex: '#FCE300' },
        { name: 'Black', hex: '#000000' },
        { name: 'Blue Gray', hex: '#2E4F66' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Nature', hex: '#D7D7D7' },
        { name: 'Green', hex: '#009639' },
        { name: 'Orange', hex: '#FF671F' },
        { name: 'Lake Blue', hex: '#0069B1' },
        { name: 'Gray 33101', hex: '#ADB1B2' },
        { name: 'Blue', hex: '#001489' },
        { name: 'Gold', hex: '#F6D86A' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Brown', hex: '#C9A381' },
        { name: 'Lime green', hex: '#88F376' },
        { name: 'Verde petrolio traslucido', hex: '#63DFCB' },
        { name: 'Light Blue', hex: '#61B0FF' },
        { name: 'Translucent light  blue', hex: '#72BBFF' },
        { name: 'Transulent Blue', hex: '#A6E9FF' },
        { name: 'Teal', hex: '#77EDD7' },
        { name: 'Clear', hex: '#EBEBEB' },
        { name: 'Pink', hex: '#F9C1BD' },
        { name: 'Translucent Gray', hex: '#8E8E8E' },
        { name: 'Translucent Olive', hex: '#748C45' },
        { name: 'Translucent Pink', hex: '#F9C1BD' },
        { name: 'Orange', hex: '#FF911A' },
        { name: 'Olive', hex: '#748C45' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Violet Purple', hex: '#583061' },
        { name: 'Malachite Green', hex: '#16B08E' },
        { name: 'Indigo Blue', hex: '#324585' },
        { name: 'Brick Red', hex: '#9F332A' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Purple', hex: '#AF1685' },
        { name: 'Blue', hex: '#0A2CA5' },
        { name: 'Yellow', hex: '#FFFF20' },
        { name: 'Azure', hex: '#489FDF' },
        { name: 'Silver', hex: '#87909A' },
        { name: 'Tangerine Yellow', hex: '#FFC72C' },
        { name: 'Grey', hex: '#8E9089' },
        { name: 'Bambu Green', hex: '#00AE42' },
        { name: 'Olive', hex: '#789D4A' },
        { name: 'Mint', hex: '#ADF4DC' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Lavender', hex: '#7248BD' },
        { name: 'Beige', hex: '#DFD1A7' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'ABS-GF',
      colors: [
        { name: 'Yellow', hex: '#FFE133' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Gray', hex: '#C6C6C6' },
        { name: 'Green', hex: '#61BF36' },
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#0C3B95' },
        { name: 'Orange', hex: '#F48438' },
        { name: 'Red', hex: '#E83100' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'White', hex: '#EFF2DE' },
        { name: 'Yellow', hex: '#FCE900' },
        { name: 'Green', hex: '#008037' },
        { name: 'Red', hex: '#E02928' },
        { name: 'Gray', hex: '#8A949E' },
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#2140B4' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Flesh', hex: '#FFF2D5' },
        { name: 'Blaze', hex: '#F1AAA8' },
        { name: 'Black', hex: '#000000' },
        { name: 'Red', hex: '#ED0000' },
        { name: 'Blue', hex: '#5898DD' },
        { name: 'Yellow', hex: '#F9EF41' },
        { name: 'Neon Green', hex: '#90FF1A' },
        { name: 'Grape Jelly', hex: '#D6ABFF' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Crystal Blue', hex: '#7EB4E1' },
        { name: 'Gray', hex: '#939393' },
        { name: 'Neon Orange', hex: '#F68B1B' },
        { name: 'Frozen', hex: '#FFFFFF' },
        { name: 'Lime Green', hex: '#EAF28F' },
        { name: 'Light Cyan', hex: '#C3E2D6' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Yellow', hex: '#F3E600' },
        { name: 'Red', hex: '#C8102E' },
        { name: 'Gray', hex: '#898D8D' },
        { name: 'Blue', hex: '#0072CE' },
      ],
    },
    {
      material: 'PA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PAHT-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PA6',
      colors: [
        { name: 'White', hex: '#EAEAE4' },
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#75AED8' },
        { name: 'Orange', hex: '#FF4800' },
        { name: 'Brown', hex: '#5B492F' },
        { name: 'Lime', hex: '#C5ED48' },
        { name: 'Gray', hex: '#353533' },
        { name: 'Yellow', hex: '#FFCE00' },
      ],
    },
    {
      material: 'PA6-CF',
      colors: [
        { name: 'Lime 72500', hex: '#C5ED48' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Clear Black', hex: '#5A5161' },
        { name: 'Transparent', hex: '#BFC3C7' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PC-FR',
      colors: [
        { name: 'White ( 63101)', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#A8A8AA' },
      ],
    },
    {
      material: 'PVA',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PPA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PPS-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
  ],
};

const CREALITY: ManufacturerCatalog = {
  name: 'Creality',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Blue', hex: '#357BED' },
        { name: 'Ender Fast PLA Orange', hex: '#FF8800' },
        { name: 'Yellow', hex: '#C2E708' },
        { name: 'Ender Value Pack Gray', hex: '#808080' },
        { name: 'Ender Grey', hex: '#404344' },
        { name: 'Orange', hex: '#FFA500' },
        { name: 'Rose Gold', hex: '#FFB9D7' },
        { name: 'CR-PLA Blue', hex: '#089DF5' },
        { name: 'Silver', hex: '#9C9EA0' },
        { name: 'Hyper Violet Tulip', hex: '#7269F7' },
        { name: 'Red', hex: '#FB0E0E' },
        { name: 'White Pine', hex: '#A47C5B' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'White  (255,255,255)', hex: '#FFFFFF' },
        { name: 'HP-Yellow', hex: '#F3E220' },
        { name: 'Soleyin Ultra - Black', hex: '#000000' },
        { name: 'Rosehip', hex: '#DD7A08' },
        { name: 'Hyper Ultramarine Green', hex: '#23AF9A' },
        { name: 'Hyper Marble', hex: '#DBE2E9' },
        { name: 'CR-PLA', hex: '#FAFAFA' },
        { name: 'White Prototyping', hex: '#FFFFFF' },
        { name: 'Grey Prototyping', hex: '#919191' },
        { name: 'Hyper Peach Fuzz', hex: '#FFE5B4' },
        { name: 'Light blue green', hex: '#B3FFFF' },
        { name: 'Ender PLA White', hex: '#FFFFFF' },
        { name: 'Ender Fast PLA Silver', hex: '#898E92' },
        { name: 'Ender Fast PLA Purple', hex: '#BB00FF' },
        { name: 'Hyper Stardust Gray', hex: '#A0A2AC' },
        { name: 'Ender Value Pack White', hex: '#FFFFFF' },
        { name: 'Ender Fast PLA', hex: '#6FFBF8' },
        { name: 'HP Ultra Green', hex: '#7CF472' },
        { name: 'Hyper Luminous Yellow', hex: '#EFEC8A' },
        { name: 'Wight', hex: '#FFFFFF' },
        { name: 'Hyper Stardust Pink', hex: '#DA8879' },
        { name: 'Hyper Light Blue Green', hex: '#7CE0D3' },
        { name: 'Ender Fast PLA Blue', hex: '#1D00F5' },
        { name: 'Ender Fast PLA Fire Red', hex: '#7A1D26' },
        { name: 'Ender Fast PLA Light Blue', hex: '#6EA2F7' },
        { name: 'Hyper Luminous Green', hex: '#76B16D' },
        { name: 'Hyper Luminous Pink', hex: '#E38090' },
        { name: 'Hyper Luminous Blue', hex: '#84BBDE' },
        { name: 'Hyper Stardust Blue', hex: '#283883' },
        { name: 'Hyper Stardust Purple', hex: '#613E5F' },
        { name: 'Hyper Stardust Coffee', hex: '#A1877F' },
        { name: 'Hyper Stardust Yellow', hex: '#F5E1A4' },
        { name: 'Hyper Stardust Orange', hex: '#EA733D' },
        { name: 'Hyper Stardust Brown', hex: '#A9533F' },
        { name: 'Hyper Stardust Green', hex: '#2F6F7A' },
        { name: 'Rainbow', hex: '#FF0000' },
        { name: 'Wild Blossom-Short', hex: '#5D90B9' },
        { name: 'Wild Blossom-Long', hex: '#5D90B9' },
        { name: 'Spring Lake', hex: '#88ABC2' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Green Apple', hex: '#7DBE46' },
        { name: 'Ender PLA+ Blue', hex: '#009DFF' },
        { name: 'Green', hex: '#C2FF9C' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Blue', hex: '#1099E8' },
        { name: 'Black', hex: '#000000' },
        { name: 'Snapdragon Yellow', hex: '#FEDC62' },
        { name: 'JADE GREEN', hex: '#33C48F' },
        { name: 'Orange', hex: '#FFA200' },
        { name: 'Grey', hex: '#858585' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'CR-Gray', hex: '#878787' },
        { name: 'Avocado Green', hex: '#77BB41' },
        { name: 'Navy Blue', hex: '#404D65' },
        { name: 'Strawberry Red', hex: '#C53A30' },
        { name: 'Ivory White', hex: '#FAFAFA' },
        { name: 'Black', hex: '#322F2D' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Golden Silver', hex: '#F7F976' },
        { name: 'Golden-Red', hex: '#BA251C' },
        { name: 'Cr-pink/purple', hex: '#D96EF7' },
        { name: 'Shiny Blue', hex: '#2B30DA' },
        { name: 'Gold/Silver', hex: '#FBF6A2' },
        { name: 'Rainbow', hex: '#5DA6EE' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Pink to White', hex: '#FFB0D3' },
        { name: 'Orange', hex: '#FF5C00' },
        { name: 'Green', hex: '#00B447' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Hyper Ochre', hex: '#CCB43E' },
        { name: 'Hyper Purple', hex: '#400052' },
        { name: 'Hyper Greyish Yellow', hex: '#807333' },
        { name: 'Ochre', hex: '#842B00' },
        { name: 'Purple', hex: '#A020F0' },
        { name: 'Hyper Dark Green', hex: '#002E29' },
        { name: 'CR-PLA Carbon', hex: '#212121' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Magenta', hex: '#E06EF7' },
        { name: 'Red', hex: '#E20303' },
        { name: 'Hyper White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#818C98' },
        { name: 'A-I Green', hex: '#49D66E' },
        { name: 'Rood / Blauw refill', hex: '#2616F8' },
        { name: 'Orange', hex: '#FF6A13' },
        { name: 'Grey refill', hex: '#AEAFB2' },
        { name: 'Green', hex: '#59EE63' },
        { name: 'Digital Blue', hex: '#01C7FC' },
        { name: 'Yellow-refill', hex: '#F1F500' },
        { name: 'Blue-refill', hex: '#3391F0' },
        { name: 'CR-White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Green', hex: '#4AAE7C' },
        { name: 'Blue', hex: '#0B50DA' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Light Purple', hex: '#D357FE' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Hyper Rocks Red Milk', hex: '#653024' },
        { name: 'Hyper Phanton Purple', hex: '#403845' },
        { name: 'Hyper Timber Green', hex: '#32464D' },
        { name: 'Hyper Night Gray', hex: '#3D3935' },
        { name: 'Hyper Brown Caramel', hex: '#774212' },
        { name: 'Hyper Night Gray Tea', hex: '#6F5D58' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'CR ABS White', hex: '#FFFFFF' },
        { name: 'CR ABS Red', hex: '#FF0000' },
        { name: 'Hyper Yellow', hex: '#FFFF00' },
        { name: 'Orange', hex: '#E16009' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'CR-ABS Gray', hex: '#445463' },
        { name: 'Hyper Pink', hex: '#F393C4' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Green', hex: '#00FF00' },
      ],
    },
    {
      material: 'PA',
      colors: [
        { name: 'Natural', hex: '#E5D3BF' },
      ],
    },
  ],
};

const DEEPLEE: ManufacturerCatalog = {
  name: 'DEEPLEE',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Green', hex: '#9EF02B' },
        { name: 'Hot pink', hex: '#FF80AC' },
        { name: 'Transparent', hex: '#FFFFFF' },
        { name: 'Brown', hex: '#895742' },
        { name: 'Sunflower Yellow', hex: '#FFD900' },
        { name: 'Space Grey', hex: '#616161' },
        { name: 'Blue grey', hex: '#6092B3' },
        { name: 'Sky Blue', hex: '#45C8D6' },
        { name: 'Black', hex: '#000000' },
        { name: 'Metallic Gold', hex: '#756214' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Turquoise', hex: '#2DACB0' },
        { name: 'Brown', hex: '#8F5D42' },
        { name: 'Yellow', hex: '#FFFF00' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Baige', hex: '#F7D497' },
        { name: 'Red', hex: '#FF0000' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Yellow', hex: '#FBFF24' },
        { name: 'Ice Blue', hex: '#84BDF5' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Gold', hex: '#D29D00' },
        { name: 'Bronze', hex: '#7C4006' },
        { name: 'SILK TREE', hex: '#0000FF' },
        { name: 'Blue Violet', hex: '#0359B0' },
        { name: 'Holly green', hex: '#0F9D76' },
        { name: 'Mint Green', hex: '#7FF0E3' },
        { name: 'White', hex: '#F2F2F3' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Brown Wood', hex: '#3B2716' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Grey', hex: '#969DA2' },
        { name: 'Green', hex: '#548B54' },
        { name: 'ORANGE', hex: '#EE9A00' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Yellow', hex: '#E0E40C' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Black pro', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
  ],
};

const ERYONE: ManufacturerCatalog = {
  name: 'Eryone',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Burnt Titanium', hex: '#252930' },
        { name: 'Pearl White', hex: '#FEFFF4' },
        { name: 'Silver', hex: '#C0C0C0' },
        { name: 'Ivory White', hex: '#DCDCD5' },
        { name: 'Burnt Titanium Galaxy', hex: '#00FF00' },
        { name: 'Military Green', hex: '#3F412C' },
        { name: 'Signal Grey', hex: '#B5AFA7' },
        { name: 'Glossy Black', hex: '#000000' },
        { name: 'Ultra Silk Bronze', hex: '#787F1A' },
        { name: 'Chinese Red', hex: '#FF0000' },
        { name: 'Milky White', hex: '#EDF0F2' },
        { name: 'Silk Silver', hex: '#C0C0C0' },
        { name: 'Black & Rose Red', hex: '#2D2D30' },
        { name: 'Mini Rainbow', hex: '#B6B443' },
        { name: 'Green and Black', hex: '#0B4514' },
        { name: 'Black / White', hex: '#000000' },
        { name: 'Macaron', hex: '#E3FFFF' },
        { name: 'Burnt Titanium Interstellar', hex: '#0010F5' },
        { name: 'Burnt Titanium Stargazer', hex: '#DB0096' },
        { name: 'Burnt Titanium Galactic', hex: '#B2831F' },
        { name: 'Gold & Purple', hex: '#F8DF7C' },
        { name: 'Steampunk', hex: '#CE91AF' },
        { name: 'Burnt Titanium Wormhole', hex: '#69F7B9' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Rainbow-Stone', hex: '#A98A6E' },
        { name: 'Ivory White', hex: '#DCDCD5' },
        { name: 'Azure', hex: '#07BCFB' },
        { name: 'Cyan', hex: '#1E9DE2' },
        { name: 'Brown', hex: '#5F2710' },
        { name: 'Purple', hex: '#8806CE' },
        { name: 'Blue', hex: '#1866E7' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Pink', hex: '#FDCEDA' },
        { name: 'Black', hex: '#000000' },
        { name: 'Olive Green', hex: '#344932' },
        { name: 'Aqua Blue', hex: '#64D9ED' },
        { name: 'Green & Fuchsia', hex: '#228B22' },
        { name: 'Red Wax', hex: '#C79074' },
        { name: 'Blue Green & Purple', hex: '#44FDFA' },
        { name: 'Rainbow Watercolor', hex: '#58A3EE' },
        { name: 'Yellow Green & Pink', hex: '#CCFD44' },
        { name: 'Shire', hex: '#00F900' },
        { name: 'Army Green', hex: '#3F412C' },
        { name: 'Mint Green', hex: '#00F0C8' },
        { name: 'Danxia', hex: '#E27429' },
        { name: 'Blue Green & Burnt Orange', hex: '#007B7A' },
        { name: 'Pink & White', hex: '#FF89D8' },
        { name: 'Dreamland', hex: '#00FFFF' },
        { name: 'PINK & BLUE', hex: '#EF06D0' },
        { name: 'Yellow & purple', hex: '#EAED0C' },
        { name: 'Salt Flat Veins', hex: '#D0DFF3' },
        { name: 'Totem Carving', hex: '#655D6C' },
        { name: 'Navy Blue', hex: '#4F6282' },
        { name: 'Frosted Mint', hex: '#B4D5DA' },
        { name: 'Maple Amber', hex: '#F9E3DD' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Blue & white', hex: '#2217BA' },
        { name: 'Hyper Speed - Coffee', hex: '#281F1C' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Gelb/Grn', hex: '#FFFB00' },
        { name: 'Aurora Dream Quad', hex: '#21357B' },
        { name: 'Metallic Iron', hex: '#000000' },
        { name: 'Red & Purple & Green', hex: '#FF0000' },
        { name: 'Teal / Orange Red', hex: '#FE7F71' },
        { name: 'Teal/Orange Red', hex: '#7AC2F5' },
        { name: 'Pink Silk', hex: '#FF40FF' },
        { name: 'Ultra Silk Copper', hex: '#D45834' },
        { name: 'Red / Blue', hex: '#91084A' },
        { name: 'Blue/Rose Red', hex: '#153FE5' },
        { name: 'Red & Blue', hex: '#E91620' },
        { name: 'Merald Green', hex: '#6EA19B' },
        { name: 'Multicolour', hex: '#928F2A' },
        { name: 'Red&Gold', hex: '#D20F0F' },
        { name: 'Rose', hex: '#F990C8' },
        { name: 'Red', hex: '#CE1C1C' },
        { name: 'Black', hex: '#5B6265' },
        { name: 'Emerald Green', hex: '#046307' },
        { name: 'Yellow / Green', hex: '#008000' },
        { name: 'Inferno', hex: '#E72323' },
        { name: 'Copper', hex: '#B34830' },
        { name: 'Emerald Green & Black', hex: '#03AA78' },
        { name: 'Steel', hex: '#BCC6CC' },
        { name: 'Macaron', hex: '#CF8769' },
        { name: 'Metal Silk Rainbow', hex: '#0000FF' },
        { name: 'Dark Green', hex: '#B1DD8B' },
        { name: 'Universe', hex: '#00FF00' },
        { name: 'Ultra Silk Silver', hex: '#A0BDCF' },
        { name: 'Rainbow Palette', hex: '#FF0000' },
        { name: 'Silk Rainbow Psychedelic', hex: '#2114BA' },
        { name: 'Ultra Silk Gold', hex: '#FBAC1A' },
        { name: 'Metallic Wolfram', hex: '#323232' },
        { name: 'Blue/Purple', hex: '#004CFF' },
        { name: 'Ultra Silk Dark Gold', hex: '#583400' },
        { name: 'Rainbow', hex: '#88ACE1' },
        { name: 'Yellow & Green', hex: '#FDF749' },
        { name: 'Metallic Copper', hex: '#444714' },
        { name: 'Black & Rose', hex: '#000000' },
        { name: 'Shadow', hex: '#FFC038' },
        { name: 'Red/Gold/Purple', hex: '#FFFF00' },
        { name: 'Evil Pool', hex: '#800080' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Blue', hex: '#2A4B7C' },
        { name: 'Silver', hex: '#999BA6' },
        { name: 'Chameleon', hex: '#AFB200' },
        { name: 'Omega Nebula', hex: '#76BB40' },
        { name: 'Glitter Black', hex: '#000000' },
        { name: 'Glitter Blue', hex: '#323586' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Galaxy Red', hex: '#8E3333' },
        { name: 'Sirius Nebula', hex: '#295059' },
        { name: 'Blue', hex: '#031D59' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Burly Wood', hex: '#B3806B' },
        { name: 'Red', hex: '#FF3A30' },
        { name: 'Wood', hex: '#B2917A' },
        { name: 'Deep Wood', hex: '#706B83' },
        { name: 'Terracotta', hex: '#DC6547' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Dark Blue', hex: '#070066' },
        { name: 'Dark Orange/Yellow', hex: '#CE5E03' },
        { name: 'Luminous Blue', hex: '#729AF8' },
        { name: 'Luminous Orange', hex: '#FFA348' },
        { name: 'Luminous Purple', hex: '#C061CB' },
        { name: 'Blue', hex: '#8EBDFB' },
        { name: 'Orange Red', hex: '#FF8000' },
        { name: 'Luminous Green', hex: '#7BF976' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Yellow', hex: '#F6E46A' },
        { name: 'White', hex: '#F5F8FA' },
        { name: 'Transparent', hex: '#FFFFFF' },
        { name: 'Galaxy Silver', hex: '#889096' },
        { name: 'Transparent Red', hex: '#FF0000' },
        { name: 'Transparent Blue', hex: '#0080FF' },
        { name: 'Galaxy Red', hex: '#B51A00' },
        { name: 'Galaxy Black', hex: '#000000' },
        { name: 'Translucent Dark Green', hex: '#013D00' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'RED', hex: '#B51A00' },
        { name: 'Rose red and blue', hex: '#DF2ABE' },
        { name: 'Trans Blue', hex: '#05558F' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Orange', hex: '#FF8000' },
      ],
    },
    {
      material: 'PETG-GF',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Orange', hex: '#FC630B' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Green', hex: '#00EB2F' },
        { name: 'Grey', hex: '#9FA0A0' },
        { name: 'Blue', hex: '#0F21EB' },
      ],
    },
    {
      material: 'ABS-GF',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Gray', hex: '#999999' },
        { name: 'Black', hex: '#000000' },
        { name: 'Yellow', hex: '#FEFB41' },
        { name: 'Blue', hex: '#1100FF' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Transparent Blue', hex: '#004A94' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Gray', hex: '#C5C7CD' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PA6',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PP',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
  ],
};

const FLASHFORGE: ManufacturerCatalog = {
  name: 'FlashForge',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Magenta', hex: '#FF00FF' },
        { name: 'Cyan', hex: '#00FFFF' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Yellow', hex: '#FFFF00' },
        { name: 'Grey', hex: '#636363' },
        { name: 'Ice Blue', hex: '#B8D9F9' },
        { name: 'Macho Pink (Gradient)', hex: '#F4A4C0' },
        { name: 'Flexible Green', hex: '#4F9A16' },
        { name: 'Gray', hex: '#8F8F8F' },
        { name: 'Skin Color', hex: '#A38564' },
        { name: 'Natural', hex: '#EAEEF1' },
        { name: 'Purple', hex: '#61187C' },
        { name: 'Pink', hex: '#C68795' },
        { name: 'Silver', hex: '#AAAAAA' },
        { name: 'Gold', hex: '#8D8600' },
        { name: 'Pearl Gentian Blue', hex: '#004D65' },
        { name: 'Black', hex: '#000000' },
        { name: 'Light Green', hex: '#6EF790' },
        { name: 'Luminous Green', hex: '#00FF00' },
        { name: 'Light Gray', hex: '#787878' },
        { name: 'Rainbow Candy', hex: '#8149E9' },
        { name: 'Galaxy Purple', hex: '#321B56' },
        { name: 'Neon Orange', hex: '#FF7300' },
        { name: 'Sky Blue', hex: '#0061FF' },
        { name: 'Green', hex: '#2EE54D' },
        { name: 'Transperent', hex: '#FFFFFF' },
        { name: 'Brown', hex: '#774632' },
        { name: 'Chameleon Skydiver Blue', hex: '#2824F9' },
        { name: 'Luminous Melody', hex: '#62F3FF' },
        { name: 'Transparent Red', hex: '#FF0000' },
        { name: 'Yellow & Blue', hex: '#00A1D8' },
        { name: 'Purple to Rose', hex: '#7915F4' },
        { name: 'Rainbow Summer Reverie', hex: '#FF6251' },
        { name: 'Blue & Pink', hex: '#5014F5' },
        { name: 'Burnt Titanium', hex: '#3E5D58' },
        { name: 'Mermaid Tears', hex: '#7DE9FF' },
        { name: 'Skydiver', hex: '#0F38AE' },
        { name: 'Summer Reverie', hex: '#BD6500' },
        { name: 'Rose Quartz', hex: '#FFA3FC' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Cool White', hex: '#F2F7FC' },
        { name: 'Gold', hex: '#C29005' },
        { name: 'Natural', hex: '#B5B5B5' },
        { name: 'Red', hex: '#FF3900' },
        { name: 'Oliver Green', hex: '#6D712E' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Silver Grey', hex: '#C0C0C0' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Orange', hex: '#FF5A00' },
        { name: 'Yellow', hex: '#FFF700' },
        { name: 'Green', hex: '#00C220' },
        { name: 'Black', hex: '#000000' },
        { name: 'Brown', hex: '#7E4C2E' },
        { name: 'Skin Color', hex: '#E7CDA1' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Green', hex: '#91C64E' },
        { name: 'Black', hex: '#090A0B' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Skin', hex: '#F0C8A3' },
        { name: 'Medium Turquoise', hex: '#5EC3CB' },
        { name: 'Gray', hex: '#6E6E6E' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Fusion Yellow-Pink', hex: '#FBFF00' },
        { name: 'Rainbow', hex: '#A1E27E' },
        { name: 'Coffee', hex: '#655953' },
        { name: 'Light Green', hex: '#88E788' },
        { name: 'Metal rainbow', hex: '#808000' },
        { name: 'Red/Yellow/Blue', hex: '#B31921' },
        { name: 'Bronze', hex: '#6F7608' },
        { name: 'Pink', hex: '#EC6ECB' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Sparkle Black', hex: '#000000' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Marble Black', hex: '#040819' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Dark', hex: '#2E2216' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Luminous Blue', hex: '#5CE6BC' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Iris Purple', hex: '#6120A2' },
        { name: 'Sailor Blue', hex: '#0000FF' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Transparent Orange', hex: '#FF4013' },
        { name: 'Nebula Purple', hex: '#2C2D74' },
        { name: 'Transparent Grey', hex: '#444444' },
        { name: 'Silver', hex: '#828282' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Transparent Yellow', hex: '#FEC700' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Purple', hex: '#A45EBE' },
        { name: 'Natural', hex: '#EFEBEB' },
        { name: 'Blue', hex: '#000078' },
        { name: 'Orange', hex: '#FFA500' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Grass Green', hex: '#669C35' },
        { name: 'Volcanic Rock Gray', hex: '#444444' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Natural', hex: '#DEE0D4' },
        { name: 'ORANGE', hex: '#FFAE00' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Gray', hex: '#3A3D40' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Red', hex: '#FF0000' },
        { name: 'Dark green', hex: '#003D0A' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Sparkle Blue', hex: '#010181' },
        { name: 'Traffic Red', hex: '#FF0000' },
        { name: 'Sky Blue', hex: '#1295F3' },
        { name: 'Blue', hex: '#4169E1' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Burnt Titanium', hex: '#2F4E6A' },
      ],
    },
  ],
};

const GEEETECH: ManufacturerCatalog = {
  name: 'Geeetech',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Purple', hex: '#813F92' },
        { name: 'Silver', hex: '#909598' },
        { name: 'Green', hex: '#57FB41' },
        { name: 'Pink', hex: '#C91AE0' },
        { name: 'Gris', hex: '#868788' },
        { name: 'Orange', hex: '#E99D48' },
        { name: 'Brown', hex: '#563D00' },
        { name: 'Chameleon', hex: '#453653' },
        { name: 'Silk Gold', hex: '#BAC19F' },
        { name: 'Matte Navy Blue', hex: '#1A2456' },
        { name: 'New Purple', hex: '#A985ED' },
        { name: 'Matte Black', hex: '#000000' },
        { name: 'Black', hex: '#000000' },
        { name: 'New White', hex: '#FFFFFF' },
        { name: 'Yellow', hex: '#FFF454' },
        { name: 'New Sand Gold', hex: '#EEBE98' },
        { name: 'New Black', hex: '#000000' },
        { name: 'New Pink', hex: '#C581AE' },
        { name: 'Bleu', hex: '#0071AE' },
        { name: 'Apple Green', hex: '#ACD55D' },
        { name: 'New Silver', hex: '#C0C0C0' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Matte Green', hex: '#263E0F' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Skin', hex: '#D5A97E' },
        { name: 'White Matte', hex: '#FFFFFF' },
        { name: 'Stone Grey', hex: '#CBCBC3' },
        { name: 'Light Grey', hex: '#A8A5A3' },
        { name: 'Matte Orange', hex: '#E7BB99' },
        { name: 'Terracotta', hex: '#FFAC80' },
        { name: 'Black', hex: '#1C2835' },
        { name: 'Grey', hex: '#C0C0C0' },
        { name: 'Matte Dark Grey', hex: '#282A2E' },
        { name: 'Blue', hex: '#1D345D' },
        { name: 'Olive Green', hex: '#1E4101' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Red Yellow Blue', hex: '#FF2600' },
        { name: 'Purple', hex: '#813F92' },
        { name: 'Gold + Purple', hex: '#FFF157' },
        { name: 'Red+Gold+Purple', hex: '#B11100' },
        { name: 'Blue/green', hex: '#439D8B' },
        { name: 'Orange Blue Green', hex: '#FF9F0F' },
        { name: 'Yellow+Green', hex: '#CBF76E' },
        { name: 'Gold Silver Copper', hex: '#E7A20D' },
        { name: 'Royal Blue', hex: '#0F3AC5' },
        { name: 'Black', hex: '#000000' },
        { name: 'Red + Blue', hex: '#864FFE' },
        { name: 'Bronze Rainbow', hex: '#292615' },
        { name: 'Gold + Silver', hex: '#C4BC00' },
        { name: 'Metallic Gold Silk Filament', hex: '#D29D00' },
        { name: 'Silk Dakr Green', hex: '#25635F' },
        { name: 'Metallic White', hex: '#FFFFFF' },
        { name: 'Silky Sky Blue', hex: '#74B5E0' },
        { name: 'Green', hex: '#22A04E' },
        { name: 'Gold black', hex: '#ECEF1F' },
        { name: 'Black + Red', hex: '#000000' },
        { name: 'Red Gold Black', hex: '#FF0000' },
        { name: 'Rainbow', hex: '#FFFFFF' },
        { name: 'Red Blue Green', hex: '#E61D0F' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Sparkly Blue', hex: '#17036A' },
        { name: 'Sparkly Purple', hex: '#650B77' },
        { name: 'Sparkly Silver', hex: '#919191' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Like Marble Blue', hex: '#DDE7ED' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Wood', hex: '#C0A78A' },
        { name: 'Poplar', hex: '#EBDDCB' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Pink', hex: '#B92D6C' },
        { name: 'Rose Red', hex: '#C061CB' },
        { name: 'Luminous Green', hex: '#20D71D' },
        { name: 'Orange', hex: '#FF7F27' },
        { name: 'Glow Yellow', hex: '#F6F9CD' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Pink', hex: '#D765C2' },
        { name: 'Metal Gold', hex: '#A76A01' },
        { name: 'Water Blue', hex: '#04AACB' },
        { name: 'Red', hex: '#8B0E18' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Transparent', hex: '#EFEFEF' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Orange', hex: '#FF8040' },
        { name: 'Skin', hex: '#FFD4C1' },
        { name: 'Apple Green', hex: '#A5EA3E' },
        { name: 'Brown', hex: '#8D4B35' },
        { name: 'Purple', hex: '#9807C0' },
        { name: 'Water Blue', hex: '#0298F2' },
        { name: 'Grey', hex: '#5C5E60' },
        { name: 'Pink', hex: '#F864A8' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'WaterBlue', hex: '#6BC1FF' },
        { name: 'Silver', hex: '#C0C0C0' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Blue', hex: '#0080FF' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Grey', hex: '#878787' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Transparent Orange', hex: '#FF8E42' },
        { name: 'Transparent Green', hex: '#7CFF6B' },
        { name: 'Transparent Yellow', hex: '#FFFF00' },
        { name: 'Transparent Blue', hex: '#0654A7' },
        { name: 'Red', hex: '#E32400' },
        { name: 'Transparent Pink', hex: '#FF56F6' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Transparent Orange', hex: '#FFAA66' },
        { name: 'Yellow', hex: '#F5E000' },
        { name: 'Transparent Red', hex: '#F85454' },
        { name: 'Black', hex: '#000000' },
      ],
    },
  ],
};

const INLAND: ManufacturerCatalog = {
  name: 'Inland',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Yellow', hex: '#F5F769' },
        { name: 'Brown', hex: '#964B00' },
        { name: 'Sand', hex: '#FDF4D3' },
        { name: 'Winter', hex: '#38D3EC' },
        { name: 'Black', hex: '#000000' },
        { name: 'Orange', hex: '#FF9A35' },
        { name: 'Pink', hex: '#FF80FF' },
        { name: 'Silk Shadow', hex: '#737373' },
        { name: 'Red', hex: '#F60909' },
        { name: 'Silk Grey', hex: '#BBC6CE' },
        { name: 'Microcenter True Green', hex: '#068F18' },
        { name: 'Dandelion', hex: '#C99B33' },
        { name: 'Shimmer Dark Red', hex: '#C43221' },
        { name: 'Purple', hex: '#A020F0' },
        { name: 'RAL 5002 blue', hex: '#053DAD' },
        { name: 'Olive Brown', hex: '#729871' },
        { name: 'Silk White', hex: '#FFFFFF' },
        { name: 'Cosplay PLA', hex: '#8D9296' },
        { name: 'True Red', hex: '#FF0000' },
        { name: 'Violet', hex: '#7F00FF' },
        { name: 'Shimmer Green', hex: '#3DBD74' },
        { name: 'Cool White', hex: '#E8E8F1' },
        { name: 'Coral', hex: '#FF4040' },
        { name: 'Green', hex: '#1F7A31' },
        { name: 'Turqoise', hex: '#40E0D0' },
        { name: 'Egyptian Blue', hex: '#005AAD' },
        { name: 'Frosty Amethyst', hex: '#C48CF3' },
        { name: 'Silver', hex: '#AAA08C' },
        { name: 'Military Brown', hex: '#585436' },
        { name: 'Military Green', hex: '#5B6D38' },
        { name: 'Frosty Mint', hex: '#7CC3AC' },
        { name: 'MINT', hex: '#C2F5E4' },
        { name: 'Pink Marble', hex: '#F0DFF1' },
        { name: 'Grey', hex: '#919191' },
        { name: 'Blue', hex: '#03168A' },
        { name: 'Light Olive', hex: '#BAB864' },
        { name: 'Silk Black', hex: '#000000' },
        { name: 'White Marble', hex: '#D6DBD3' },
        { name: 'Inland Blue', hex: '#0AC0F5' },
        { name: 'Frosty Winter', hex: '#36E5FF' },
        { name: 'Matte Blue', hex: '#45ADF7' },
        { name: 'Shimmer Gold', hex: '#C59B84' },
        { name: 'Red Raspberry', hex: '#C63527' },
        { name: 'Cornflower Blue', hex: '#1D78A5' },
        { name: 'Silk Rose-Gold', hex: '#EFCFB1' },
        { name: 'Twinkling Gold', hex: '#A08A66' },
        { name: 'Light Brown', hex: '#BF9C81' },
        { name: 'Glass Watermelon', hex: '#D7192C' },
        { name: 'Glass Light Blue', hex: '#329EEC' },
        { name: 'Coral Red', hex: '#FF4040' },
        { name: 'True Green', hex: '#8DC15C' },
        { name: 'Gold', hex: '#FFD22B' },
        { name: 'Blue/Green', hex: '#00FFFF' },
        { name: 'Glass watermelon red', hex: '#DC1E70' },
        { name: 'Autumn Orange Grey', hex: '#73521E' },
        { name: 'Bronze Red', hex: '#C30909' },
        { name: 'Orange/Gray', hex: '#4B3024' },
        { name: 'Frosty Purple-Pink', hex: '#BF3AE4' },
        { name: 'Color Changing (UV)', hex: '#E8ECDF' },
        { name: 'Glass Yellow', hex: '#FFF824' },
        { name: 'Summer Translucent Blue Green', hex: '#00F7DE' },
        { name: 'Glass Orange', hex: '#FF9500' },
        { name: 'Light Blue', hex: '#0000FF' },
        { name: 'Spring Yellow/Green/Blue', hex: '#E7F76E' },
        { name: 'Blue / Purple', hex: '#311BDA' },
        { name: 'Glass Purple', hex: '#800080' },
        { name: 'Rainbow 2', hex: '#EF2D1F' },
        { name: 'Wood Rainbow', hex: '#957F41' },
        { name: 'Winter Blue White', hex: '#00FDFF' },
        { name: 'Natural To Purple UV', hex: '#9F79D7' },
        { name: 'Gray to Natural', hex: '#959595' },
        { name: 'Dark Purple', hex: '#2F2934' },
        { name: 'Natural to Red', hex: '#E8E8F1' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Orange', hex: '#ED7D27' },
        { name: 'Brown', hex: '#534941' },
        { name: 'Orange Spooless', hex: '#FF7B00' },
        { name: 'Blue Pro', hex: '#0433FF' },
        { name: 'Blue', hex: '#007DD6' },
        { name: 'Luminous Blue', hex: '#78EAF2' },
        { name: 'Gray', hex: '#7B7B80' },
        { name: 'Luminous Green', hex: '#6BFF97' },
        { name: 'Black', hex: '#000000' },
        { name: 'Orange, 2025', hex: '#FF9200' },
        { name: 'Beige', hex: '#F5CAB7' },
        { name: 'Magenta', hex: '#C62F7C' },
        { name: 'Natural', hex: '#EDEDED' },
        { name: 'Green', hex: '#129F8B' },
        { name: 'Periwinkle Blue', hex: '#7775CA' },
        { name: 'Bone White', hex: '#DADBC1' },
        { name: 'Red', hex: '#CA0D0E' },
        { name: 'Neon Green', hex: '#06F202' },
        { name: 'White Marble', hex: '#B7C5D3' },
        { name: 'CMYK White', hex: '#FBFAF2' },
        { name: 'Forest Green', hex: '#2A7C54' },
        { name: 'Olive Green', hex: '#55623C' },
        { name: 'CMYK Cyan', hex: '#15A3C7' },
        { name: 'Light Brown', hex: '#AA7941' },
        { name: 'Orange (LRV 37)', hex: '#F0894C' },
        { name: 'Light Blue', hex: '#6ACFFD' },
        { name: 'Gold', hex: '#D7B537' },
        { name: 'Silver', hex: '#C0C0C0' },
        { name: 'Milky White', hex: '#FFF7F7' },
        { name: 'Yellow', hex: '#FEDD00' },
        { name: 'YELLOW MARBLE', hex: '#D2C285' },
        { name: 'CMYK Yellow', hex: '#FFFF00' },
        { name: 'Space Blue', hex: '#B3D9FF' },
        { name: 'CMYK Magenta', hex: '#F62681' },
        { name: 'Red Raspberry', hex: '#C63527' },
        { name: 'Pink', hex: '#F4A4C0' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Illuminated Blue', hex: '#0095FF' },
        { name: 'Raspberry Red', hex: '#DF0C16' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Metallic Silver', hex: '#B2B2B0' },
        { name: 'Purple', hex: '#7832E2' },
        { name: 'Carbon Fiber', hex: '#000000' },
        { name: 'Cold White', hex: '#FFFFFF' },
        { name: 'Orange', hex: '#FF8000' },
        { name: 'Blue', hex: '#0544FF' },
        { name: 'Metallic Gold', hex: '#DE9B3B' },
        { name: 'Khaki', hex: '#BFB688' },
        { name: 'Light Olive', hex: '#C6CD34' },
        { name: 'Dark Gray', hex: '#696969' },
        { name: 'True Red', hex: '#B13137' },
        { name: 'Lulz Green', hex: '#B3FF80' },
        { name: 'Light Gray', hex: '#E1E1E1' },
        { name: 'Light Blue', hex: '#81D3F8' },
        { name: 'Yellow', hex: '#FFBB3F' },
        { name: 'Gray', hex: '#ACACAC' },
        { name: 'Metallic Dk Blue', hex: '#043B62' },
        { name: 'White Marble', hex: '#BDBDBD' },
        { name: 'Green', hex: '#047106' },
        { name: 'Metallic Dark Red', hex: '#8B3A3A' },
        { name: 'Pink', hex: '#FC97B0' },
        { name: 'Brown', hex: '#6E432D' },
        { name: 'Dark Blue', hex: '#1D65A0' },
        { name: 'Metallic Bronze', hex: '#935100' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Black Orange', hex: '#FF8F20' },
        { name: 'Peach', hex: '#F2B67A' },
        { name: 'Turquoise', hex: '#53D5FD' },
        { name: 'Lulz green', hex: '#C7F76E' },
        { name: 'Yellow', hex: '#F8D00D' },
        { name: 'Green-Brown', hex: '#486247' },
        { name: 'Frosty Amethyst', hex: '#C48CF3' },
        { name: 'Banana', hex: '#CECC88' },
        { name: 'Chocolate (LRV 11)', hex: '#735648' },
        { name: 'White', hex: '#E0E3E5' },
        { name: 'Pink', hex: '#F291A5' },
        { name: 'Green', hex: '#03FC86' },
        { name: 'Peach (LRV 55)', hex: '#F7B68A' },
        { name: 'Pastel Pink', hex: '#FFA8A8' },
        { name: 'Yellow-Red', hex: '#F3E325' },
        { name: 'BLACK-WHITE', hex: '#858585' },
        { name: 'Inland Blue', hex: '#1C81F0' },
        { name: 'Gray-Orange', hex: '#FFB363' },
        { name: 'Gray-Purple', hex: '#E392FE' },
        { name: 'Purple', hex: '#AA89C4' },
        { name: 'Black-red', hex: '#000000' },
        { name: 'Light Pink (LRV  57)', hex: '#DBC2B0' },
        { name: 'Brick Red', hex: '#800000' },
        { name: 'Matte Rainbow', hex: '#94E3FE' },
        { name: 'Clay Rainbow', hex: '#DDCEB5' },
        { name: 'Blue', hex: '#6CBEF9' },
        { name: 'Brick Red (LRV 14)', hex: '#B24143' },
        { name: 'Black-White', hex: '#000000' },
        { name: 'Light Pink', hex: '#D3B6A6' },
        { name: 'Brown', hex: '#303030' },
        { name: 'Light Blue', hex: '#B4E7F9' },
        { name: 'Orange', hex: '#FF9D5C' },
        { name: 'Denim', hex: '#4F88B0' },
        { name: 'Chocolate', hex: '#785646' },
        { name: 'Army Purple', hex: '#2C002B' },
        { name: 'Ash Grey', hex: '#3B4045' },
        { name: 'Black (LRV 3)', hex: '#2D2F2E' },
        { name: 'Matte Black-White', hex: '#000000' },
        { name: 'Red Heather', hex: '#D95D5D' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Cyan', hex: '#0084BD' },
        { name: 'Gold/Silver', hex: '#C59120' },
        { name: 'Rainbow 3', hex: '#D357FE' },
        { name: 'Gold/Red', hex: '#F7E469' },
        { name: 'Gold Red Green', hex: '#6EF797' },
        { name: 'Gold/Green/Black', hex: '#E7F76E' },
        { name: 'Rainbow 2', hex: '#53D5FD' },
        { name: 'Silk Jacinth', hex: '#FF4013' },
        { name: 'Purple', hex: '#8000FF' },
        { name: 'Silk Yellow', hex: '#FFFC41' },
        { name: 'Black-Silver', hex: '#C0C0C0' },
        { name: 'Blue-Yellow', hex: '#0095FF' },
        { name: 'Gray-Green', hex: '#C8FEDD' },
        { name: 'Frosty Evergreen', hex: '#074B31' },
        { name: 'Meteor', hex: '#2E9475' },
        { name: 'Twilight', hex: '#886C93' },
        { name: 'Blue/Orange/Green', hex: '#FF8000' },
        { name: 'Lime/Magenta', hex: '#E3E839' },
        { name: 'Gold/Magenta', hex: '#EB2498' },
        { name: 'Magenta', hex: '#FF00FF' },
        { name: 'Dark Yellow', hex: '#D4A625' },
        { name: 'Mystic', hex: '#008000' },
        { name: 'Blue/Green', hex: '#17B6DE' },
        { name: 'Gold', hex: '#D7B537' },
        { name: 'Blue/Silver', hex: '#3692D3' },
        { name: 'Pewter', hex: '#787E82' },
        { name: 'Green', hex: '#04D57C' },
        { name: 'Silver', hex: '#B5C1C6' },
        { name: 'Gold/Purple', hex: '#C06EF7' },
        { name: 'Blue Silver', hex: '#61B7F5' },
        { name: 'Army Green', hex: '#3F5758' },
        { name: 'Red', hex: '#FF0059' },
        { name: 'Blue-Green', hex: '#00BAC7' },
        { name: 'Cool Pink', hex: '#E7BFFC' },
        { name: 'Orange', hex: '#FF8000' },
        { name: 'Silk Amber Gold', hex: '#B97A22' },
        { name: 'Silk Lime', hex: '#69F781' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Twinkling Black', hex: '#000000' },
        { name: 'Nebula', hex: '#76647B' },
        { name: 'Twilight', hex: '#1E3445' },
        { name: 'Twinkling Silver', hex: '#D5DCD7' },
        { name: 'Comet', hex: '#0D8736' },
        { name: 'Red', hex: '#B51A00' },
        { name: 'Blue-black', hex: '#383F56' },
        { name: 'Aurora', hex: '#78A4C4' },
        { name: 'Gold', hex: '#806848' },
        { name: 'Stellar', hex: '#000000' },
        { name: 'Meteor', hex: '#38571A' },
        { name: 'Purple', hex: '#9313A4' },
        { name: 'Shimmer Light Blue', hex: '#607184' },
        { name: 'Blue-Black', hex: '#383F56' },
        { name: 'Light Blue', hex: '#607184' },
        { name: 'Shimmer Yellow', hex: '#D38301' },
        { name: 'Grey', hex: '#A6A8AB' },
        { name: 'Burgundy', hex: '#883340' },
        { name: 'Glitter Pink', hex: '#FF80FF' },
        { name: 'Dark Red', hex: '#8B0000' },
        { name: 'Dark Gray', hex: '#696969' },
        { name: 'Twinkling Blue', hex: '#001547' },
        { name: 'Twinkle Rainbow', hex: '#FF0019' },
        { name: 'Shimmer Blue', hex: '#0062A8' },
        { name: 'Twinkling Purple', hex: '#9606CB' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Galaxy Green', hex: '#004745' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Blue Marble', hex: '#00FCFF' },
        { name: 'Slate Gray Marble', hex: '#ADD8E6' },
        { name: 'Purple Marble', hex: '#C487F6' },
        { name: 'White Marble', hex: '#D6DBD3' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Wood', hex: '#F5C66D' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Orange', hex: '#F7B76E' },
        { name: 'Pink', hex: '#FF00FF' },
        { name: 'Gold', hex: '#FFF76B' },
        { name: 'Yellow', hex: '#FFFF80' },
        { name: 'Luminous', hex: '#FFFFFF' },
        { name: 'Luminous Blue', hex: '#C7E6FC' },
        { name: 'Glow In Dark Fluro Blue', hex: '#0000FF' },
        { name: 'Green', hex: '#77BB41' },
        { name: 'Luminous/Glow In The Dark', hex: '#D3CFB5' },
        { name: 'Glow in Dark Fluro Purple', hex: '#856EF7' },
        { name: 'Rainbow', hex: '#FFFFFF' },
        { name: 'Luminous Rainbow', hex: '#1F10EA' },
        { name: 'Glow-in-the-Dark Green', hex: '#AEF359' },
        { name: 'Red', hex: '#FF6962' },
        { name: 'Purple', hex: '#D97DD4' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Red', hex: '#330000' },
        { name: 'Purple', hex: '#300160' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Orange', hex: '#FF781F' },
        { name: 'Blue', hex: '#0433FF' },
        { name: 'Yellow', hex: '#FFFF00' },
        { name: 'Black', hex: '#000000' },
        { name: 'Dark Grey', hex: '#5A5A5A' },
        { name: 'Silver', hex: '#C0BFBC' },
        { name: 'Green', hex: '#52AE0D' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Dark Purple', hex: '#301934' },
        { name: 'Red', hex: '#C40000' },
        { name: 'Purple', hex: '#703984' },
        { name: 'Grey', hex: '#808080' },
        { name: 'True Red', hex: '#AA0911' },
        { name: 'Gray', hex: '#5C5C5C' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Silver', hex: '#7B7474' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Red', hex: '#E22400' },
        { name: 'Orange', hex: '#FF8800' },
        { name: 'Grey', hex: '#6C6C6C' },
        { name: 'Blue', hex: '#0000FF' },
        { name: 'Green', hex: '#009325' },
        { name: 'Magenta', hex: '#E14171' },
        { name: 'Purple', hex: '#4F0DA0' },
        { name: 'Yellow', hex: '#FFF824' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Blackish Green', hex: '#002C1D' },
        { name: 'Dark Blue', hex: '#002D4D' },
        { name: 'Dark Grey', hex: '#595959' },
        { name: 'Antique Brass', hex: '#CE9451' },
        { name: 'Black', hex: '#000000' },
        { name: 'Blackish Red', hex: '#392928' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Red', hex: '#FA0019' },
        { name: 'Glow In The Dark', hex: '#FEFFFF' },
        { name: 'Light Blue', hex: '#6EEEF7' },
        { name: 'Black', hex: '#000000' },
        { name: 'True Red', hex: '#97141A' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Blue', hex: '#0000FF' },
        { name: 'Grey (LRV 4)', hex: '#545856' },
        { name: 'Natural', hex: '#CBCFB0' },
        { name: 'Neon Green', hex: '#04FF00' },
        { name: 'Grey', hex: '#808080' },
        { name: 'Silver', hex: '#808080' },
        { name: 'Galaxy Black', hex: '#000000' },
        { name: 'Purple', hex: '#5D017E' },
      ],
    },
    {
      material: 'ABS-GF',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Green', hex: '#69F785' },
        { name: 'Orange', hex: '#E87130' },
        { name: 'Olive Brown', hex: '#342300' },
        { name: 'Grey', hex: '#6E6E6E' },
        { name: 'Vibrant Blue', hex: '#6CCCF9' },
        { name: 'Purple', hex: '#8000FF' },
        { name: 'Red', hex: '#F46250' },
        { name: 'Vibrant Green', hex: '#67F052' },
        { name: 'Sprinkle Green', hex: '#669D34' },
        { name: 'Brown', hex: '#775C50' },
        { name: 'Army Green', hex: '#518266' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Blue', hex: '#1100FF' },
        { name: 'Green', hex: '#39FF14' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Purple', hex: '#8B3DFF' },
        { name: 'Natural', hex: '#D9D9D9' },
        { name: 'Pink', hex: '#DF417B' },
        { name: 'Rainbow', hex: '#E60005' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Translucent Blue', hex: '#1708E7' },
        { name: 'Grey', hex: '#808080' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Translucent Orange', hex: '#B0361A' },
        { name: 'Black for MFS', hex: '#000000' },
        { name: 'Translucent Red', hex: '#C0242F' },
        { name: 'Translucent Purple', hex: '#B82E5E' },
        { name: 'Translucent Yellow', hex: '#D9FF70' },
      ],
    },
    {
      material: 'PA',
      colors: [
        { name: 'Natural', hex: '#FEF19A' },
      ],
    },
    {
      material: 'PA-CF',
      colors: [
        { name: 'Natural', hex: '#000000' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'Transparent', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
  ],
};

const KINGROON: ManufacturerCatalog = {
  name: 'Kingroon',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'ORANGE LIGHT', hex: '#FD9330' },
        { name: 'Cyan', hex: '#00FFFF' },
        { name: 'Skin light beige', hex: '#F4CEA3' },
        { name: 'Gold', hex: '#E2DAA6' },
        { name: 'Dark Green', hex: '#4E7A27' },
        { name: 'Dark Grey', hex: '#555550' },
        { name: 'Sky Blue', hex: '#87CEEB' },
        { name: 'Skin', hex: '#FEC3C3' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Silver', hex: '#7A7A7A' },
        { name: 'Red', hex: '#E32400' },
        { name: 'Yellow', hex: '#F7E523' },
        { name: 'Black', hex: '#000000' },
        { name: 'Gray', hex: '#C0C0C0' },
        { name: 'Blue', hex: '#0056D6' },
        { name: 'Orange', hex: '#E6AF55' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Blue Grey', hex: '#3F3F5D' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Yellow', hex: '#DEDB4B' },
        { name: 'Green', hex: '#95D0A4' },
        { name: 'Black', hex: '#000000' },
        { name: 'Grass Green', hex: '#27A098' },
        { name: 'Dark blue', hex: '#021C36' },
        { name: 'Red', hex: '#F90B0B' },
        { name: 'Light Blue', hex: '#92C4F7' },
        { name: 'White', hex: '#CBCAC8' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Red, Green, Magenta', hex: '#D72344' },
        { name: 'Blue/Golden', hex: '#0433FF' },
        { name: 'Black', hex: '#000000' },
        { name: 'Yellow', hex: '#FFFF80' },
        { name: 'Copper', hex: '#C05029' },
        { name: 'Blue', hex: '#0056D6' },
        { name: 'Purple, Green, Rose Red', hex: '#813D9C' },
        { name: 'Yellow, Blue, Green', hex: '#F8E45C' },
        { name: 'Golden', hex: '#F0A552' },
        { name: 'Golden green blue', hex: '#E6B11F' },
        { name: 'Golden green black', hex: '#E6B11F' },
        { name: 'Golden, Green, Rose Red', hex: '#E6B11F' },
        { name: 'Black Red', hex: '#FF0000' },
        { name: 'Golden Red', hex: '#F0A552' },
        { name: 'Black Golden', hex: '#F0A552' },
        { name: 'Yellow Green', hex: '#FFFF00' },
        { name: 'Red, Golden, Purple', hex: '#D72344' },
        { name: 'Blue, Green, Purple', hex: '#0000FF' },
        { name: 'Black Blue', hex: '#000000' },
        { name: 'Golden, purple red, blue', hex: '#E6B11F' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Wood Brown', hex: '#B07C4F' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Purple', hex: '#DBA3F5' },
        { name: 'White/green', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Metal Silver', hex: '#AAA9AD' },
        { name: 'Grey', hex: '#BAB8B5' },
        { name: 'Yellow', hex: '#E2B930' },
        { name: 'Deep Blue', hex: '#004879' },
        { name: 'Red', hex: '#EF0022' },
        { name: 'Sky Blue', hex: '#45C4EF' },
        { name: 'Blue', hex: '#001CEF' },
        { name: 'Pink', hex: '#E2B2B0' },
        { name: 'Orange', hex: '#FF9300' },
        { name: 'Green', hex: '#00FF00' },
        { name: 'Skin', hex: '#FDDDBF' },
        { name: 'Purple', hex: '#670C79' },
        { name: 'Silver', hex: '#A4B2BC' },
        { name: 'Brown', hex: '#964B00' },
        { name: 'Gray', hex: '#A1A1A1' },
        { name: 'Black', hex: '#000000' },
        { name: 'Transparent', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Blue', hex: '#1111FF' },
        { name: 'White', hex: '#E1E2E2' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Black', hex: '#000000' },
        { name: 'Grey', hex: '#707070' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Grey', hex: '#A0A1A2' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Yellow', hex: '#FFF820' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Blue', hex: '#00007F' },
        { name: 'Red', hex: '#F8000F' },
        { name: 'Green', hex: '#019974' },
      ],
    },
    {
      material: 'PA-CF',
      colors: [
        { name: 'Nylon-CF Black', hex: '#000000' },
      ],
    },
    {
      material: 'PA6',
      colors: [
        { name: 'White', hex: '#DDDDDD' },
      ],
    },
  ],
};

const MATTERHACKERS: ManufacturerCatalog = {
  name: 'Matterhackers',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Magenta', hex: '#CD4264' },
        { name: 'Silver/Purple', hex: '#D5D5D5' },
        { name: 'Blue Yellow', hex: '#001CA8' },
        { name: 'Raspberry Gold', hex: '#A80062' },
        { name: 'Green', hex: '#3F6C3F' },
        { name: 'Grey', hex: '#6B6B6B' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Light Blue', hex: '#77BCEE' },
        { name: 'Brown', hex: '#A55103' },
        { name: 'Black', hex: '#000000' },
        { name: 'Dark Green', hex: '#103102' },
        { name: 'Natural', hex: '#F7D4AB' },
        { name: 'Purple', hex: '#A700F5' },
        { name: 'Orange', hex: '#FF6F0B' },
        { name: 'Pink', hex: '#E17ADD' },
        { name: 'RGB Red', hex: '#FF0000' },
        { name: 'RGB Green', hex: '#39FF14' },
        { name: 'RGB Blue', hex: '#202EEE' },
        { name: 'Forrest Green', hex: '#669C35' },
        { name: 'Navy Blue', hex: '#17216B' },
        { name: 'Pink Purple', hex: '#F76EE4' },
        { name: 'Silver', hex: '#808285' },
        { name: 'Blue Green', hex: '#0318BA' },
        { name: 'Clay Red', hex: '#D45F5F' },
        { name: 'Purple Gold', hex: '#C7C005' },
        { name: 'Clear', hex: '#D4DCDF' },
        { name: 'Yellow', hex: '#EBC100' },
        { name: 'Blue', hex: '#0A5CFF' },
        { name: 'Tan', hex: '#EECFAC' },
        { name: 'Blue Raspberry', hex: '#EE009E' },
        { name: 'Forest Green', hex: '#004D0F' },
        { name: 'White', hex: '#FEFFFF' },
        { name: 'Lime Green', hex: '#75BA53' },
        { name: 'Green Raspberry', hex: '#1D6A01' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Light Blue', hex: '#1991DC' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Blue', hex: '#1420C8' },
        { name: 'Red', hex: '#C81E37' },
        { name: 'Parthenon Gray', hex: '#DEDEDE' },
        { name: 'Solar Flare', hex: '#BA6868' },
        { name: 'Translucent Orange', hex: '#FD7C18' },
        { name: 'Translucent light blue', hex: '#0081C2' },
        { name: 'Translucent yellow', hex: '#EDB555' },
        { name: 'Translucent Red', hex: '#E54932' },
        { name: 'Translucent Purple', hex: '#BC13FE' },
        { name: 'Firefly Green', hex: '#95F505' },
        { name: 'Teal Blue', hex: '#0097A7' },
        { name: 'Cotton Candy Pink', hex: '#F6A7C1' },
        { name: 'Electric Orange', hex: '#FF6A00' },
        { name: 'Jet Gray', hex: '#515560' },
        { name: 'Electric Yellow', hex: '#FFE300' },
        { name: 'Antares Red', hex: '#D0001F' },
        { name: 'Ice Blue', hex: '#A5B6CF' },
        { name: 'Midnight Blue', hex: '#3E3D71' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Tortoise Green', hex: '#296308' },
        { name: 'Succulent Green', hex: '#90BE3C' },
        { name: 'Merlot Red', hex: '#7F4754' },
        { name: 'Lilac Pastel', hex: '#C6B8FF' },
        { name: 'Caribbean Blue', hex: '#1792DE' },
        { name: 'Lime Green', hex: '#43B02A' },
        { name: 'Burgundy', hex: '#7F171F' },
        { name: 'Jet Gray', hex: '#474B4D' },
        { name: 'Parthenon Gray Marble', hex: '#DEDEDE' },
        { name: 'Teal Blue', hex: '#0097A7' },
        { name: 'Translucent Aqua', hex: '#5FA7AD' },
        { name: 'Emerald Green', hex: '#50C878' },
        { name: 'Purple', hex: '#7A368F' },
        { name: 'Gray', hex: '#474B4D' },
        { name: 'Burnt Orange', hex: '#CC5500' },
        { name: 'Translucent Violet', hex: '#603BA0' },
        { name: 'Antares Red', hex: '#D0001F' },
        { name: 'Orange', hex: '#FF6A00' },
        { name: 'Regolith Gray', hex: '#4F4F4F' },
        { name: 'Light Blue', hex: '#3598E2' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Purple', hex: '#C13CD3' },
        { name: 'Rose Gold', hex: '#E08300' },
        { name: 'Gold Silver', hex: '#CBB658' },
        { name: 'Fuchsia Green', hex: '#A53152' },
        { name: 'Blue Green', hex: '#4147C0' },
        { name: 'Silky Yellow', hex: '#F3F707' },
        { name: 'Silky Pink', hex: '#FE6CAE' },
        { name: 'Silky Silver', hex: '#BDBDB9' },
        { name: 'Gold', hex: '#FFC321' },
        { name: 'Copper', hex: '#C76F36' },
        { name: 'Silver', hex: '#CACACA' },
        { name: 'Teal', hex: '#008080' },
        { name: 'Pink Blue', hex: '#6C75BB' },
        { name: 'Gold Magenta', hex: '#B78727' },
        { name: 'Blue', hex: '#0067FD' },
        { name: 'Blue Yellow', hex: '#45B1E8' },
        { name: 'Bronze', hex: '#49371B' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Glow in the Dark (Galaxy)', hex: '#000000' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Green Glow', hex: '#88E788' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Green', hex: '#08F738' },
        { name: 'Orange', hex: '#FF9500' },
        { name: 'Grey', hex: '#868FA6' },
        { name: 'Yellow', hex: '#FEFB00' },
        { name: 'Red', hex: '#FF2600' },
        { name: 'Purple', hex: '#4C2791' },
        { name: 'White', hex: '#E9EBF1' },
        { name: 'Blue', hex: '#0A5CFF' },
        { name: 'Silver', hex: '#868FA6' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Orange', hex: '#F9A006' },
        { name: 'Blue', hex: '#0A5CFF' },
        { name: 'Clear', hex: '#D5DDDC' },
        { name: 'Gray', hex: '#808080' },
        { name: 'Purple', hex: '#B40BF0' },
        { name: 'Green', hex: '#4F7A28' },
        { name: 'Red', hex: '#831100' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Orange', hex: '#FF8000' },
        { name: 'Grey', hex: '#A9A9A9' },
        { name: 'White', hex: '#FEFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Crimson Red', hex: '#E91A2B' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Clear', hex: '#FFFFFF' },
        { name: 'Natural', hex: '#EDE9E3' },
        { name: 'Translucent Purple', hex: '#BC13FE' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'White', hex: '#FEFFFF' },
      ],
    },
    {
      material: 'PA12-CF',
      colors: [
        { name: 'NylonX-Black', hex: '#000000' },
      ],
    },
  ],
};

const POLYMAKER: ManufacturerCatalog = {
  name: 'Polymaker',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Red', hex: '#FB0404' },
        { name: 'Pink', hex: '#FFA3C0' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Periwinkle', hex: '#3A87FE' },
        { name: 'Silk Orange', hex: '#F14700' },
        { name: 'Light Blue', hex: '#5FA5FA' },
        { name: 'Jadeite Silk Green-Chrome', hex: '#4BE2A8' },
        { name: 'Tan', hex: '#A79E82' },
        { name: 'Brown', hex: '#65493C' },
        { name: 'Ash Grey', hex: '#3C464E' },
        { name: 'Black', hex: '#070707' },
        { name: 'Metallic Blue', hex: '#2D3449' },
        { name: 'Luminous Pink', hex: '#FE9176' },
        { name: 'Azure Blue', hex: '#0066D9' },
        { name: 'Blue', hex: '#003776' },
        { name: 'Galaxy', hex: '#383B35' },
        { name: 'Grey', hex: '#2DA1A6' },
        { name: 'Metallic Silver', hex: '#7A838E' },
        { name: 'Galaxy Black', hex: '#1F1F1B' },
        { name: 'Lime Green', hex: '#A1B302' },
        { name: 'Bright Yellow', hex: '#E6C937' },
        { name: 'Gradient Tropical', hex: '#F7A269' },
        { name: 'Orange', hex: '#EF7A3E' },
        { name: 'Magenta', hex: '#FF3D6E' },
        { name: 'Metallic Green', hex: '#434D43' },
        { name: 'Cotton White', hex: '#FFFBF6' },
        { name: 'Dark Green', hex: '#263E0F' },
        { name: 'Green', hex: '#05AF47' },
        { name: 'Teal', hex: '#5FCCB7' },
        { name: 'Bright Red', hex: '#E63521' },
        { name: 'Silk Lime', hex: '#B2F75F' },
        { name: 'Silk Blue', hex: '#1A72BD' },
        { name: 'Jungle Green', hex: '#4E742D' },
        { name: 'Wood', hex: '#D2A273' },
        { name: 'Cream', hex: '#F5E8D1' },
        { name: 'Silk Dark Blue', hex: '#23599A' },
        { name: 'Cold White', hex: '#D9DFE5' },
        { name: 'Peach Fuzz', hex: '#FFA57D' },
        { name: 'Panchroma Jungle Green', hex: '#4E742D' },
        { name: 'Starlight Aurora', hex: '#0061FE' },
        { name: 'Silk Chrome', hex: '#62717F' },
        { name: 'Starlight Twilight', hex: '#0061FE' },
        { name: 'Candy', hex: '#DABCC8' },
        { name: 'Silk Bronze', hex: '#641501' },
        { name: 'Steel Grey', hex: '#616469' },
        { name: 'Metallic Bronze', hex: '#926043' },
        { name: 'Metallic Gold', hex: '#DA9F1D' },
        { name: 'Silk Rose Gold', hex: '#A56F6B' },
        { name: 'Pastel Peanut', hex: '#C29572' },
        { name: 'White 1', hex: '#E2DEDB' },
        { name: 'Silk Rose', hex: '#780A0A' },
        { name: 'Silk Pink', hex: '#FFA7C4' },
        { name: 'Yellow', hex: '#F0C940' },
        { name: 'Bright Green', hex: '#BDD901' },
        { name: 'Bright Orange', hex: '#F07806' },
        { name: 'Silk White', hex: '#DBD1C7' },
        { name: 'Gradient Celestial Blue-Purple', hex: '#6ADCF7' },
        { name: 'Panchroma Temp Shift', hex: '#80FF80' },
        { name: 'Silk Air', hex: '#FFFFFF' },
        { name: 'Silk Fire Gradient', hex: '#E63946' },
        { name: 'Glow in the dark green', hex: '#00FF00' },
        { name: 'Gradient Fire', hex: '#E13951' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Red', hex: '#FF2600' },
        { name: 'Dark Grey', hex: '#4C732C' },
        { name: 'Light Yellow', hex: '#F3D561' },
        { name: 'Purple', hex: '#7758B4' },
        { name: 'Orange', hex: '#F07009' },
        { name: 'Metallic Green', hex: '#263E0F' },
        { name: 'Cold White', hex: '#D6D5DC' },
        { name: 'Gradient Fire', hex: '#E13951' },
        { name: 'White', hex: '#EBECED' },
        { name: 'Purple PA07011', hex: '#6547A5' },
        { name: 'Green', hex: '#6CCB72' },
        { name: 'Yellow', hex: '#FFFF00' },
        { name: 'Blue', hex: '#0064B9' },
        { name: 'Black', hex: '#151515' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Grat', hex: '#B0B0B0' },
        { name: 'Yellow', hex: '#FFE800' },
        { name: 'True Grey', hex: '#C7C7C7' },
        { name: 'Green', hex: '#53C37F' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Earth Brown', hex: '#725349' },
        { name: 'Army Beige', hex: '#D3B6A3' },
        { name: 'Muted Green', hex: '#8D9886' },
        { name: 'Dual Colour RedShadow', hex: '#8A0526' },
        { name: 'Army Purple', hex: '#433C4D' },
        { name: 'Matte Army Dark Green', hex: '#5F6244' },
        { name: 'Fossil Grey', hex: '#868D96' },
        { name: 'Savannah Yellow', hex: '#F4C35D' },
        { name: 'White Marble', hex: '#DDDBE1' },
        { name: 'Shadow Red', hex: '#D51515' },
        { name: 'Sunrise Orange', hex: '#F78E0E' },
        { name: 'Marble Sandstone', hex: '#F2DEA6' },
        { name: 'Sunrise Orange Matte', hex: '#F78E0E' },
        { name: 'Sapphire Blue Matte', hex: '#005AA2' },
        { name: 'Forest Green', hex: '#60AD70' },
        { name: 'Muted Purple', hex: '#7A5F8A' },
        { name: 'Wood Brown', hex: '#AC8161' },
        { name: 'Peach', hex: '#F2B67A' },
        { name: 'White (For Production)', hex: '#F3EFEB' },
        { name: 'Matte Blue', hex: '#0064B9' },
        { name: 'Black/Red', hex: '#131D2A' },
        { name: 'Marble Slate Grey', hex: '#A2DDBE' },
        { name: 'Mixed Berries', hex: '#CB3028' },
        { name: 'Rose', hex: '#FF5C74' },
        { name: 'Neon Green', hex: '#00F263' },
        { name: 'Gradient Winter', hex: '#B9D9F9' },
        { name: 'Gradient Pastel rainbow', hex: '#FFF4BD' },
        { name: 'Pastel Peach', hex: '#F6BF8B' },
        { name: 'Cotton White', hex: '#F7F7F7' },
        { name: 'Metallic Silver', hex: '#A5C8FF' },
        { name: 'Black', hex: '#1C1C1C' },
        { name: 'Shadow Orange', hex: '#FFA500' },
        { name: 'Lime Green', hex: '#56ED2C' },
        { name: 'Wine red', hex: '#D60212' },
        { name: 'Pastel rainbow', hex: '#E0EBFF' },
        { name: 'Ice blue', hex: '#4B8ECE' },
        { name: 'Pastel Periwinkle', hex: '#CDCCFF' },
        { name: 'CAMOUFLAGE', hex: '#9A8145' },
        { name: 'Yellow', hex: '#EDFB28' },
        { name: 'Arctic Teal', hex: '#73CEC8' },
        { name: 'Sapphire Blue', hex: '#1375A5' },
        { name: 'Summer', hex: '#D0E740' },
        { name: 'Spring', hex: '#F2B67A' },
        { name: 'Fall', hex: '#DF9900' },
        { name: 'Summer (Green Gradient)', hex: '#93D775' },
        { name: 'Sky Blue', hex: '#1AC5FC' },
        { name: 'Pastel Mint', hex: '#BEC9A5' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Shiny Orange', hex: '#EB6232' },
        { name: 'Silk Purple', hex: '#C968FD' },
        { name: 'Silver', hex: '#7D7D7D' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Silk Rainbow', hex: '#ED719E' },
        { name: 'Creatrix Silk Red', hex: '#CB0100' },
        { name: 'Bronze', hex: '#641501' },
        { name: 'Magenta', hex: '#D329F5' },
        { name: 'Banquet (Gold-Magenta)', hex: '#B8813C' },
        { name: 'Silk Red', hex: '#C1443F' },
        { name: 'Pink', hex: '#E8A498' },
        { name: 'Sovereign (Gold-Purple)', hex: '#D29D00' },
        { name: 'Black', hex: '#302E30' },
        { name: 'Panchroma Metallic Bronze', hex: '#926043' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Sorcerer\'s Red', hex: '#A23A3C' },
        { name: 'Celestial Yellow', hex: '#FFF618' },
        { name: 'Celestial Green', hex: '#87D1BA' },
        { name: 'Celestial Light Yellow', hex: '#E3DF85' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Wood', hex: '#D2A273' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Luminous Blue', hex: '#5FA8C2' },
        { name: 'Glow Orange', hex: '#CBD0B4' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'White', hex: '#EEEBEA' },
        { name: 'Translucent Dark Grey', hex: '#767B7F' },
        { name: 'Grey', hex: '#A7AEB2' },
        { name: 'Purple', hex: '#6947B8' },
        { name: 'Dark Blue', hex: '#081B36' },
        { name: 'Silver', hex: '#75787B' },
        { name: 'Dark Green', hex: '#223622' },
        { name: 'Green', hex: '#38B837' },
        { name: 'Dark Gray', hex: '#363D40' },
        { name: 'Yellow', hex: '#FFC845' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Fiberon (Black)', hex: '#000000' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Voron Red', hex: '#CD3746' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Yellow', hex: '#FFFF00' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'TPU90 White', hex: '#FFFFFF' },
        { name: 'Yellow', hex: '#FEDD00' },
        { name: 'TPU95 Yellow', hex: '#FEDD00' },
        { name: 'RED', hex: '#B11010' },
        { name: 'TPU95-HF', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PA',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Natural', hex: '#EFEED7' },
      ],
    },
    {
      material: 'PA6',
      colors: [
        { name: 'Grey', hex: '#75787B' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PPS-CF',
      colors: [
        { name: 'Black', hex: '#302E2F' },
      ],
    },
    {
      material: 'CPE',
      colors: [
        { name: 'Tan', hex: '#A79E82' },
        { name: 'Magenta', hex: '#F24574' },
        { name: 'Orange', hex: '#F67405' },
        { name: 'Grey', hex: '#8C9099' },
        { name: 'Panchroma CoPE Magenta', hex: '#F24574' },
      ],
    },
  ],
};

const PRUSA: ManufacturerCatalog = {
  name: 'Prusa',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Lipstick red', hex: '#FF0000' },
        { name: 'Azure blue', hex: '#3D8AD1' },
        { name: 'Pineapple Yellow', hex: '#E2E600' },
        { name: 'Roval blue', hex: '#002AFF' },
        { name: 'Lime green', hex: '#77DD69' },
        { name: 'Galaxy green', hex: '#153720' },
        { name: 'Simply green', hex: '#49F35D' },
        { name: 'Galaxy purple', hex: '#4B0977' },
        { name: 'Silver', hex: '#999AA0' },
        { name: 'Jet black', hex: '#000000' },
        { name: 'Glow green', hex: '#A5F76E' },
        { name: 'Lila', hex: '#DE9EE0' },
        { name: 'Prusa Orange', hex: '#FF4D08' },
        { name: 'Galaxy Black', hex: '#000000' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Lithophane', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Sweet mint', hex: '#A1E3E1' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Silver', hex: '#737373' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Silver', hex: '#999AA0' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Slate Silver', hex: '#55575A' },
        { name: 'Turquoise Blue', hex: '#00FFEF' },
        { name: 'Signal Wei', hex: '#FFFFFF' },
        { name: 'Jet Black', hex: '#292B2B' },
        { name: 'Galaxy Black', hex: '#000000' },
        { name: 'Orange', hex: '#FF7B00' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Clear', hex: '#FFFFFF' },
        { name: 'Violet', hex: '#EE82EE' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Silver', hex: '#E6E8FA' },
        { name: 'Yellowgreen', hex: '#9ACD32' },
      ],
    },
  ],
};

const PRUSAMENT: ManufacturerCatalog = {
  name: 'Prusament',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Pineapple Yellow', hex: '#EFD00B' },
        { name: 'Goldfish LE 2025', hex: '#E06900' },
        { name: 'Pristine White', hex: '#E6EAEF' },
        { name: 'Noctua Beige', hex: '#C8CCBE' },
        { name: 'Mystic Green', hex: '#4E5742' },
        { name: 'Viva La Bronze', hex: '#B38E3F' },
        { name: 'Pearl Blue', hex: '#2B37D4' },
        { name: 'Blood Red', hex: '#990203' },
        { name: 'Gentleman\'s Grey', hex: '#354047' },
        { name: 'Azure Blue', hex: '#0082AD' },
        { name: 'Algae', hex: '#674B42' },
        { name: 'Opal Green', hex: '#065B4A' },
        { name: 'Royal Blue', hex: '#00518F' },
        { name: 'Corn', hex: '#B27B46' },
        { name: 'Natural', hex: '#DFDFD3' },
        { name: 'Pearl White', hex: '#D0D7D8' },
        { name: 'Prusa Orange', hex: '#EA5E1A' },
        { name: 'My Silverness', hex: '#AEB8C1' },
        { name: 'Galaxy Silver', hex: '#D5D5D5' },
        { name: 'Gravity Grey', hex: '#9FA4A8' },
        { name: 'Oh My Gold', hex: '#CE9F2E' },
        { name: 'Radiant Sky', hex: '#0042AA' },
        { name: 'Risotto', hex: '#CCC9C0' },
        { name: 'Radiant Sky LE 2024', hex: '#150DB5' },
        { name: 'Simply Green', hex: '#70A641' },
        { name: 'Noctua Brown', hex: '#4F2506' },
        { name: 'Army Green', hex: '#5E6345' },
        { name: 'Wine', hex: '#5E4940' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Mystic Brown', hex: '#482E31' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Silver', hex: '#999AA0' },
        { name: 'Green', hex: '#42663A' },
        { name: 'Anniversary LE 2023', hex: '#690FD7' },
        { name: 'Red', hex: '#8A2924' },
        { name: 'Galaxy Black', hex: '#3D3E3D' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Marble Grey', hex: '#B0B4B5' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Chocolate Brown', hex: '#8A6F57' },
        { name: 'Linden Light', hex: '#EECFAE' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Coffee Bronz', hex: '#7A4A00' },
        { name: 'Ocean Blue', hex: '#194C55' },
        { name: 'Slate Silver', hex: '#595856' },
        { name: 'Pistachio Green', hex: '#93A683' },
        { name: 'Chalky Blue', hex: '#6F9AAA' },
        { name: 'Froggy Gold', hex: '#785800' },
        { name: 'Jet Black', hex: '#24292A' },
        { name: 'Matte black', hex: '#020105' },
        { name: 'Grey', hex: '#605F55' },
        { name: 'Jungle Green', hex: '#007249' },
        { name: 'Tungsten 75%', hex: '#292C2E' },
        { name: 'Yellow Gold', hex: '#9A8524' },
        { name: 'Prusa Orange', hex: '#EA5E1A' },
        { name: 'Terracotta Light', hex: '#B87F6A' },
        { name: 'Signal White', hex: '#E3DFD9' },
        { name: 'Clear', hex: '#E4E7E5' },
        { name: 'Natural', hex: '#F2F5E0' },
        { name: 'Matt Black', hex: '#303635' },
        { name: 'Black', hex: '#12150D' },
        { name: 'Mango Yellow', hex: '#F2B70A' },
        { name: 'Anthracite Grey', hex: '#3F4647' },
        { name: 'Galaxy Black', hex: '#3D3E3D' },
      ],
    },
    {
      material: 'PETG Pro',
      colors: [
        { name: 'Green', hex: '#5AECCB' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Ultramarine Blue', hex: '#2B3B61' },
        { name: 'Neon Green', hex: '#A6EC5F' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Carbon Fiber Black', hex: '#000000' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Sapphire Blue', hex: '#3B4468' },
        { name: 'Saphire Blue', hex: '#3B4467' },
        { name: 'Jet Black', hex: '#000000' },
        { name: 'Black', hex: '#3D3E3D' },
        { name: 'Green', hex: '#5AECCB' },
        { name: 'Natural', hex: '#DFDFD3' },
        { name: 'Lipstick Red', hex: '#D02F37' },
        { name: 'Signal White', hex: '#E3DFD9' },
        { name: 'Prusa Orange', hex: '#EA5E1A' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Natural', hex: '#FFF8DF' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'Urban Grey', hex: '#999596' },
        { name: 'Black', hex: '#262727' },
        { name: 'Natural', hex: '#DEE7ED' },
        { name: 'Jet Black', hex: '#24292A' },
        { name: 'Orange', hex: '#EA5E1A' },
        { name: 'Pro Green', hex: '#5AECCB' },
      ],
    },
    {
      material: 'PP-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PP-GF',
      colors: [
        { name: 'Natural', hex: '#DBDBD2' },
      ],
    },
  ],
};

const SUNLU: ManufacturerCatalog = {
  name: 'SUNLU',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Cherry Red', hex: '#FF615F' },
        { name: 'Pink Meta', hex: '#FF80C0' },
        { name: 'Sakura Pink', hex: '#EBB7CB' },
        { name: 'Yellow', hex: '#FFFF80' },
        { name: 'Wei', hex: '#FFFFFF' },
        { name: 'Mint Grn Meta', hex: '#21DEB8' },
        { name: 'Light Gold', hex: '#F1BE48' },
        { name: 'Black', hex: '#000000' },
        { name: 'Coffee', hex: '#A27639' },
        { name: 'Twinkling Blue', hex: '#A3D7FC' },
        { name: 'Grey', hex: '#C0C0C0' },
        { name: 'Olive Green', hex: '#415324' },
        { name: 'Red', hex: '#C0434E' },
        { name: 'Orange', hex: '#AB4C16' },
        { name: 'Green', hex: '#96D35F' },
        { name: 'Oliver Green', hex: '#649A65' },
        { name: 'Rainbow 05', hex: '#FF9300' },
        { name: 'Transparent Rainbow 01', hex: '#FF0000' },
        { name: 'PLA Silver', hex: '#C6C6C7' },
        { name: 'Grass Green', hex: '#11B07B' },
        { name: 'Transparent Red', hex: '#FF0000' },
        { name: 'Ceramic', hex: '#D9D9D9' },
        { name: 'Transparent Blue', hex: '#0000FF' },
        { name: 'Light Blue', hex: '#94E3FE' },
        { name: 'Sunny Orange', hex: '#ED7334' },
        { name: 'Transparent Orange', hex: '#F8B525' },
        { name: 'Burly Wood', hex: '#D5BA95' },
        { name: 'Lavender Purple', hex: '#4D22B2' },
        { name: 'Turquoise Cyan', hex: '#00FFFF' },
        { name: 'Orange (SUNLU Site)', hex: '#F19850' },
        { name: 'Blue(Klein Blue)', hex: '#002FA7' },
        { name: 'Gold', hex: '#C69B3F' },
        { name: 'Lemon Yellow', hex: '#FBE988' },
        { name: 'Twinkling Black', hex: '#000000' },
        { name: 'Oreo Marble', hex: '#C0C0C0' },
        { name: 'Sky Blue', hex: '#15A9C2' },
        { name: 'Rainbow 04', hex: '#FFF994' },
        { name: 'Rainbow 02', hex: '#982ABC' },
        { name: 'Rainbow 03', hex: '#F93489' },
        { name: 'Transparant Geel', hex: '#EEFF00' },
        { name: 'Rainbow 01', hex: '#33C759' },
        { name: 'Transparent Rainbow-04', hex: '#F1D6AD' },
        { name: 'RAINBOW', hex: '#EFCAFF' },
        { name: 'Ocean Haze', hex: '#74A7FF' },
        { name: 'Mint Ice', hex: '#7AD3BF' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Orange', hex: '#F67415' },
        { name: 'Cherry Red', hex: '#D93B47' },
        { name: 'Solid Black', hex: '#01010C' },
        { name: 'Olive Green', hex: '#35591F' },
        { name: 'Rainbow 02', hex: '#1920F5' },
        { name: 'Yellow', hex: '#EFCD42' },
        { name: 'Transparent Green', hex: '#65FE59' },
        { name: 'Sky blue', hex: '#0CB7CC' },
        { name: 'Roasted Chestnut', hex: '#9D8C7C' },
        { name: 'Black SPLA', hex: '#000000' },
        { name: 'Blue', hex: '#381AAE' },
        { name: 'Grey', hex: '#4A4850' },
        { name: 'CMYK', hex: '#00ACD0' },
        { name: 'Lavendel Violett', hex: '#685BC7' },
        { name: 'White SPLA', hex: '#FFFFFF' },
        { name: 'Green', hex: '#05AA3C' },
        { name: 'Black', hex: '#000000' },
        { name: 'Roasted Chestnut Black', hex: '#252321' },
        { name: 'Red/Yellow/Green/Black', hex: '#8C415D' },
        { name: 'Lemon Yellow', hex: '#FFFFAF' },
        { name: 'Amarillo', hex: '#FFFF00' },
        { name: 'Red', hex: '#C5463F' },
        { name: 'Mintgrn', hex: '#59D9AA' },
        { name: 'Pink', hex: '#FFA8D2' },
        { name: 'Silver', hex: '#8F8F8F' },
        { name: 'Beige', hex: '#EDC9AF' },
        { name: 'Blue Gray', hex: '#668FB7' },
        { name: 'Rainbow', hex: '#F50579' },
        { name: 'Fuchsia', hex: '#A235C0' },
        { name: 'White', hex: '#E9F0FE' },
        { name: 'Apple Green', hex: '#B5F2AB' },
        { name: 'Klein Blue', hex: '#0042A9' },
        { name: 'Grass Green', hex: '#45A184' },
        { name: 'Transparent Blue', hex: '#0000FF' },
        { name: 'Midnight', hex: '#1A1F73' },
        { name: 'Blue Grey', hex: '#6B98FE' },
        { name: 'Purple', hex: '#BC8EFF' },
        { name: 'Transparent Purple', hex: '#8018E7' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Cherry Red', hex: '#F7423A' },
        { name: 'Filament Blue', hex: '#0C309D' },
        { name: 'PLA Meta White', hex: '#ABCDEF' },
        { name: 'Grey', hex: '#757575' },
        { name: 'Blue Red', hex: '#1A35F4' },
        { name: 'Yellow', hex: '#F4E04D' },
        { name: 'Ocean Blue', hex: '#99D6EA' },
        { name: 'Clay', hex: '#858585' },
        { name: 'Lavender Purple', hex: '#8C568A' },
        { name: 'Lemon Yellow', hex: '#E1EFAE' },
        { name: 'Light blue', hex: '#57F2F4' },
        { name: 'Sakura Pink', hex: '#E3B5D9' },
        { name: 'Black Red', hex: '#000000' },
        { name: 'Klein Blue', hex: '#002FA7' },
        { name: 'Sprout Green', hex: '#DDFF00' },
        { name: 'Olive green', hex: '#808000' },
        { name: 'Yellow Cyan', hex: '#00D5FF' },
        { name: 'Pink', hex: '#FFDCEB' },
        { name: 'Cyan', hex: '#88BFFF' },
        { name: 'Magenta', hex: '#DA63C4' },
        { name: 'CMYK', hex: '#88BFFF' },
        { name: 'Purple', hex: '#8C568A' },
        { name: 'Kevin blue', hex: '#002FA7' },
        { name: 'Powder Blue', hex: '#B8E3E9' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: '4 BLU/PUR/ORG/YEL', hex: '#0008F5' },
        { name: 'Silver', hex: '#C6CBD0' },
        { name: 'Yellow', hex: '#EBB612' },
        { name: 'Watermelon Red', hex: '#FA0000' },
        { name: 'Dark Purple', hex: '#400080' },
        { name: 'Orange', hex: '#DF7930' },
        { name: 'Chocolate', hex: '#462700' },
        { name: 'Red Yellow Green', hex: '#B8D61F' },
        { name: 'Punk Brass', hex: '#C9B361' },
        { name: '4 RED/YEL/GRN/BLK', hex: '#FF0000' },
        { name: '4 BLU/PUR/RED/GLD', hex: '#1405EB' },
        { name: 'Rainbow', hex: '#FF4DBE' },
        { name: 'Orange, Blue, Green', hex: '#F79B69' },
        { name: 'Bronze', hex: '#B1DD8B' },
        { name: 'EliteSilk Silver', hex: '#CBFFFF' },
        { name: '4 BLK/GRY/RED/YEL', hex: '#00000A' },
        { name: 'Rainbow 03', hex: '#FB2898' },
        { name: 'Gold/Black', hex: '#050505' },
        { name: 'Rainbow 05', hex: '#FF3A2F' },
        { name: 'Red,Yellow,Green,Black', hex: '#CD545B' },
        { name: 'Punk Green', hex: '#199469' },
        { name: 'Punk Bronze', hex: '#A18B55' },
        { name: 'Black, Gray, Red, Yellow', hex: '#000000' },
        { name: 'Rainbow 01', hex: '#88F769' },
        { name: 'Blue/Green/Purple', hex: '#7998CC' },
        { name: 'Transparent Rainbow 04', hex: '#B70101' },
        { name: 'Blue green', hex: '#00DBD8' },
        { name: 'Gold', hex: '#EDC53F' },
        { name: 'Black Gold Purple', hex: '#000000' },
        { name: 'Rainbow 06', hex: '#E870A5' },
        { name: 'Red', hex: '#F03B45' },
        { name: 'Blue Purple Red Gold', hex: '#1F28A8' },
        { name: 'Black/Purple', hex: '#6A45BF' },
        { name: 'Black Grey Red Yellow', hex: '#0A0A0A' },
        { name: 'Blue Purple Orange Yellow', hex: '#1F28A8' },
        { name: 'Red Yellow Green Black', hex: '#92072A' },
        { name: 'Black Purple', hex: '#1E1F20' },
        { name: 'Green/Purple', hex: '#308C6A' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'Stardust Purple', hex: '#170542' },
        { name: 'Galaxy Green', hex: '#31524B' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Chestnut Brown Marble', hex: '#BFB9B4' },
        { name: 'White Oreo', hex: '#EBEBEB' },
        { name: 'Brick Red', hex: '#683B48' },
        { name: 'Shadow Storm', hex: '#ACBAC8' },
        { name: 'Oreo Marble', hex: '#D4D4D1' },
        { name: 'Ashen Concrete', hex: '#8F8F8F' },
      ],
    },
    {
      material: 'PLA Wood',
      colors: [
        { name: 'Maple', hex: '#D6C783' },
        { name: 'Cherry', hex: '#7A4835' },
        { name: 'Wood  (181,146,89)', hex: '#B59259' },
        { name: 'Maple Wood', hex: '#DBC0A0' },
        { name: 'Cherry Wood', hex: '#775A56' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'White to Blue', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Gold', hex: '#FFD700' },
        { name: 'Military Green', hex: '#2C5F34' },
        { name: 'Black / Czarny', hex: '#000000' },
        { name: 'Space Grey', hex: '#707070' },
        { name: 'Elite Green', hex: '#49DD08' },
        { name: 'Elite Yellow', hex: '#EDE077' },
        { name: 'Elite Soft Purple', hex: '#7F8CCC' },
        { name: 'White Matte', hex: '#FFFFFF' },
        { name: 'Elite Digital Blue', hex: '#0000FF' },
        { name: 'Black', hex: '#000400' },
        { name: 'Silver', hex: '#BEBFC7' },
        { name: 'Clay', hex: '#A59F8C' },
        { name: 'Lemon Yellow', hex: '#FFFF80' },
        { name: 'Graphite', hex: '#45494E' },
        { name: 'Green', hex: '#49E463' },
        { name: 'Grey', hex: '#525456' },
        { name: 'Chocolate', hex: '#9A7A6D' },
        { name: 'Vibrant Yellow', hex: '#CC9F24' },
        { name: 'Sakura Pink', hex: '#FFBAC3' },
        { name: 'Gray', hex: '#75787B' },
        { name: 'Cherry Red', hex: '#FC6D5C' },
        { name: 'Elite Bright Orange', hex: '#FF7034' },
        { name: 'Sky Blue', hex: '#6ACBF6' },
        { name: 'Midewed Red', hex: '#FF0000' },
        { name: 'Purple', hex: '#A84CCC' },
        { name: 'Mint Green', hex: '#33F6D8' },
        { name: 'Elite Sunny Orange', hex: '#FF8B48' },
        { name: 'Blue', hex: '#005EBD' },
        { name: 'Rainbow 01', hex: '#FF0000' },
        { name: 'Oak', hex: '#C2B29A' },
        { name: 'Army Green', hex: '#2C5F34' },
        { name: 'Olive', hex: '#808040' },
        { name: 'Ceramic White', hex: '#F4F9FF' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Clear', hex: '#FFFFFF' },
        { name: 'Green', hex: '#12E22B' },
        { name: 'Red', hex: '#D90D0D' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'White', hex: '#F8F8F8' },
        { name: 'True Yellow', hex: '#FACF0A' },
        { name: 'Safety Yellow', hex: '#F7F749' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Light Gold', hex: '#FFF157' },
        { name: 'Gold', hex: '#785700' },
        { name: 'Grey', hex: '#64686C' },
        { name: 'Black', hex: '#000000' },
        { name: 'Klein Blue', hex: '#282099' },
        { name: 'Beige', hex: '#F3E0D6' },
        { name: 'Roasted Chestnut', hex: '#3E2B2D' },
        { name: 'Yellow', hex: '#F8E700' },
        { name: 'Olive Green', hex: '#67823C' },
        { name: 'Purple (Lavender)', hex: '#685BC7' },
        { name: 'Pink', hex: '#F9A6B0' },
        { name: 'Natural White', hex: '#F2F2F2' },
        { name: 'Oro Opaco', hex: '#CDA434' },
        { name: 'Purple', hex: '#8000FF' },
        { name: 'Midnight', hex: '#283348' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Yellow', hex: '#F5EC00' },
        { name: 'Natural', hex: '#EEEFE7' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Royal Blue', hex: '#0033FF' },
        { name: 'Cream White', hex: '#FCFBF4' },
        { name: 'Burgundy', hex: '#410000' },
        { name: 'Black', hex: '#000000' },
        { name: 'Dark Blue', hex: '#333667' },
        { name: 'Pink', hex: '#E63B7A' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Azure', hex: '#0080FF' },
        { name: 'Light Blue', hex: '#ADD8E6' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Grey', hex: '#444444' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Wine Red', hex: '#B83A4B' },
        { name: 'Azure', hex: '#0080FF' },
      ],
    },
    {
      material: 'PA',
      colors: [
        { name: 'Natural', hex: '#F5F2ED' },
      ],
    },
    {
      material: 'PA6',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Grey', hex: '#929292' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'Natural', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PP',
      colors: [
        { name: 'Natural', hex: '#FFFFFF' },
      ],
    },
  ],
};

const ESUN: ManufacturerCatalog = {
  name: 'eSUN',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Litho White', hex: '#FFFFFF' },
        { name: 'Litho Magenta', hex: '#FF40FF' },
        { name: 'Litho Yellow', hex: '#FFFB00' },
        { name: 'Litho Cyan', hex: '#00FDFF' },
        { name: 'Natural', hex: '#EBCFA7' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Fire Engine Red', hex: '#910000' },
        { name: 'Light Brown', hex: '#9B7348' },
        { name: 'Silk Candy Red Gold Blue', hex: '#AA1537' },
        { name: 'Bone', hex: '#F7E1CA' },
        { name: 'Grey', hex: '#929292' },
        { name: 'Orange', hex: '#EF774A' },
        { name: 'Red', hex: '#FE343E' },
        { name: 'Beige', hex: '#FFE2CB' },
        { name: 'Rosa', hex: '#FFC0CB' },
        { name: 'Sky Blue', hex: '#87CEEB' },
        { name: 'Green', hex: '#1F4C35' },
        { name: 'Deep Black', hex: '#000000' },
        { name: 'Barbie Pink', hex: '#EE719E' },
        { name: 'Silk Candy Red Gold', hex: '#E40E30' },
        { name: 'Silk Candy Blue Green', hex: '#0D5CC7' },
        { name: 'Light Gray', hex: '#667B92' },
        { name: 'Silver', hex: '#999999' },
        { name: 'Dark Blue', hex: '#101670' },
        { name: 'Peak Green', hex: '#BAFF72' },
        { name: 'Olive Green', hex: '#435D50' },
        { name: 'Glass Lemon Yellow', hex: '#FAFA33' },
        { name: 'Glass Light Blue', hex: '#3872A8' },
        { name: 'Glass Watermelon Red', hex: '#ED333B' },
        { name: 'Nebula Purple', hex: '#8A6AF6' },
        { name: 'Morning Glory', hex: '#F07F79' },
        { name: 'Glass Purple', hex: '#773E7E' },
        { name: 'Clear', hex: '#D9C9FE' },
        { name: 'Glass Orange', hex: '#FF8B4D' },
        { name: 'Dark Shiny Violet', hex: '#705B6E' },
        { name: 'Ice Blue', hex: '#9FD6FE' },
        { name: 'Purple', hex: '#0D44E7' },
        { name: 'Dark Twnkling Blue', hex: '#204B6A' },
        { name: 'Dark twinkling green', hex: '#006400' },
        { name: 'Raspberry Red', hex: '#F77269' },
        { name: 'Chameleon Raspberry Red', hex: '#FF4013' },
        { name: 'Pink', hex: '#EFCCED' },
      ],
    },
    {
      material: 'PLA+',
      colors: [
        { name: 'Candy Pink', hex: '#EAA1B2' },
        { name: 'Peach Pink', hex: '#FFF9F5' },
        { name: 'Space Blue', hex: '#4AC3F0' },
        { name: 'Magenta', hex: '#C41B70' },
        { name: 'Periwinkle Blue', hex: '#8972E9' },
        { name: 'Holly Green', hex: '#004D28' },
        { name: 'Baby Blue', hex: '#98FFFF' },
        { name: 'Matcha Green', hex: '#C1F469' },
        { name: 'Lilac', hex: '#DEBBFF' },
        { name: 'Haze Blue', hex: '#3B6FA0' },
        { name: 'Coral Orange', hex: '#FF572F' },
        { name: 'Jade Green', hex: '#33C48F' },
        { name: 'Yellow', hex: '#FCE300' },
        { name: 'Cyan', hex: '#0086D6' },
        { name: 'Baby Pink', hex: '#DDA3B0' },
        { name: 'Grass Green', hex: '#009952' },
        { name: 'Light Blue', hex: '#169BEA' },
        { name: 'Translucent', hex: '#E3E9ED' },
        { name: 'Rot', hex: '#EA0027' },
        { name: 'RGB Red', hex: '#FF0000' },
        { name: 'Apricot', hex: '#FFCF56' },
        { name: 'Mustard Green', hex: '#E4FF82' },
        { name: 'Mint Green', hex: '#D8FFE6' },
        { name: 'Almond Yellow', hex: '#FFFFC3' },
        { name: 'Skin', hex: '#F9CB9C' },
        { name: 'Luminous Blue', hex: '#FFFFFF' },
        { name: 'Violet', hex: '#6E3CA0' },
        { name: 'Milky White', hex: '#D9E0E3' },
        { name: 'Light Grey', hex: '#B4B4B9' },
        { name: 'Brick Red', hex: '#9B5347' },
        { name: 'Hot Pink', hex: '#FF46A2' },
        { name: 'Light Brown', hex: '#9B7348' },
        { name: 'Gold', hex: '#FFA933' },
        { name: 'Morandi green', hex: '#00542B' },
        { name: 'Beige', hex: '#FFFFD8' },
      ],
    },
    {
      material: 'PLA Pro',
      colors: [
        { name: 'Green', hex: '#034654' },
      ],
    },
    {
      material: 'PLA Matte',
      colors: [
        { name: 'Purple Yellow', hex: '#A245D3' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Fire Engine Red', hex: '#91202B' },
        { name: 'Green Pink', hex: '#00F900' },
        { name: 'Brown', hex: '#B18D76' },
        { name: 'Paddy Field', hex: '#80C25A' },
        { name: 'Ocean', hex: '#A8C9DA' },
        { name: 'Pastels', hex: '#9ED7FF' },
        { name: 'Fruit Candy', hex: '#A45B9B' },
        { name: 'Cream White', hex: '#FEFCDD' },
        { name: 'Macaron (CWBeJfAj0101084)', hex: '#6E77F7' },
        { name: 'Black Red', hex: '#000000' },
        { name: 'Light Khaki', hex: '#FFFFCF' },
        { name: 'Olive Green', hex: '#3F5C0E' },
        { name: 'Rainbow a', hex: '#FDBEFB' },
        { name: 'Light Kakhi', hex: '#DED1BE' },
        { name: 'Tangerine', hex: '#F19837' },
        { name: 'Green Purple', hex: '#76C27B' },
        { name: 'Matte Rainbow', hex: '#D0E3F0' },
      ],
    },
    {
      material: 'PLA Silk',
      colors: [
        { name: 'Gold Silver Copper', hex: '#E7A20D' },
        { name: 'Grey', hex: '#919191' },
        { name: 'Candy (Red, Gold, Blue)', hex: '#FF0000' },
        { name: 'Rainbow', hex: '#52D6FC' },
        { name: 'Dark Twinkling Blue', hex: '#0042AA' },
        { name: 'Dark Twinkling Green', hex: '#263E0F' },
        { name: 'Universe', hex: '#49B2FD' },
        { name: 'Magic', hex: '#FF0000' },
        { name: 'Mystic', hex: '#452603' },
        { name: 'Gold', hex: '#F1B731' },
        { name: 'White', hex: '#E3E0DD' },
        { name: 'Dark Yellow', hex: '#D4A62F' },
        { name: 'Green', hex: '#7FCB44' },
        { name: 'Yellow', hex: '#DED74C' },
        { name: 'Red', hex: '#C94831' },
        { name: 'Purple', hex: '#8350A5' },
        { name: 'Black Gold', hex: '#000000' },
        { name: 'Cyan', hex: '#32A7D0' },
        { name: 'Pink', hex: '#FBA7E5' },
        { name: 'Lime Green', hex: '#A0CE4A' },
        { name: 'Candy gold blue green', hex: '#FFA85C' },
        { name: 'Gold Silver', hex: '#B09C8F' },
        { name: 'Red Gold', hex: '#C94831' },
        { name: 'Morning Glow', hex: '#B92D5D' },
        { name: 'Violet (FBeJcBj01C)', hex: '#DF0C7C' },
        { name: 'Silk Rose Gold', hex: '#E7A18E' },
        { name: 'Silver', hex: '#B1B1B3' },
        { name: 'Red Green Gold', hex: '#6A8355' },
        { name: 'Peach', hex: '#FFA57D' },
        { name: 'Red/Green', hex: '#FF0000' },
        { name: 'Purple/Gold', hex: '#23178B' },
        { name: 'Scorching Sun', hex: '#E57E2A' },
        { name: 'Blue/Silver', hex: '#003166' },
        { name: 'Copper/Purple/Green', hex: '#8F5443' },
        { name: 'Coral', hex: '#FFDD00' },
        { name: 'Dark Twinkling Gold', hex: '#3F550E' },
        { name: 'Gold/Green/Black', hex: '#E7A20D' },
        { name: 'Gold Green Black', hex: '#896326' },
        { name: 'Rose/Gold', hex: '#C7886C' },
        { name: 'Black/Green', hex: '#295002' },
        { name: 'Antique Brass', hex: '#998165' },
        { name: 'Light Green', hex: '#72F269' },
        { name: 'Rainbow A', hex: '#DE946F' },
        { name: 'Black Purple', hex: '#531CBA' },
        { name: 'Jacinth', hex: '#EE422A' },
      ],
    },
    {
      material: 'PLA Sparkle',
      colors: [
        { name: 'Purple', hex: '#800080' },
        { name: 'ETwinkling Gold', hex: '#FFBB29' },
        { name: 'ETwinkling Clear', hex: '#D6D6D6' },
        { name: 'ETwinkling Pink', hex: '#FFC0CB' },
        { name: 'ETwinkling Warm Orange', hex: '#AF4846' },
        { name: 'Black', hex: '#080808' },
        { name: 'ETwinkling Red', hex: '#990000' },
        { name: 'ETwinkling Black', hex: '#000000' },
        { name: 'ETwinkling Blue', hex: '#2A47A5' },
        { name: 'ETwinkling Silver', hex: '#D1D1D1' },
        { name: 'ETwinkling Purple', hex: '#8080FF' },
      ],
    },
    {
      material: 'PLA Galaxy',
      colors: [
        { name: 'EStars Galaxy Black', hex: '#131A1B' },
      ],
    },
    {
      material: 'PLA Marble',
      colors: [
        { name: 'Green (Hornfels)', hex: '#5C684E' },
        { name: 'Blue (Blueschist)', hex: '#0061FF' },
        { name: 'Sandstone', hex: '#DAB399' },
        { name: 'Pegmatite', hex: '#6A5F5E' },
        { name: 'Tiger-porphyry', hex: '#FFFFFF' },
        { name: 'Limestone', hex: '#363C42' },
      ],
    },
    {
      material: 'PLA Fluo',
      colors: [
        { name: 'Luminous Blue', hex: '#0433FF' },
        { name: 'Orange', hex: '#EF774A' },
        { name: 'Luminous Purple', hex: '#874EFE' },
        { name: 'Clear', hex: '#C2C2C2' },
      ],
    },
    {
      material: 'PLA-CF',
      colors: [
        { name: 'Purple', hex: '#1A0330' },
        { name: 'Brown', hex: '#7D6E56' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG',
      colors: [
        { name: 'Almond Yellow', hex: '#F4F4A6' },
        { name: 'Fire Engine Red', hex: '#8D091E' },
        { name: 'Orange translucent', hex: '#F76600' },
        { name: 'Solid Green', hex: '#088C3B' },
        { name: 'Translucent', hex: '#FFFFFF' },
        { name: 'Solid Grey', hex: '#979797' },
        { name: 'Orange', hex: '#ED7A4A' },
        { name: 'Solid Gold', hex: '#B4A647' },
        { name: 'Solid Yellow', hex: '#F1F50F' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG Translucent',
      colors: [
        { name: 'Natural', hex: '#FFFFFF' },
        { name: 'Purple', hex: '#982ABC' },
        { name: 'Magenta', hex: '#9C020B' },
        { name: 'Green', hex: '#0D2D0B' },
        { name: 'Yellow', hex: '#F0CA42' },
        { name: 'Grey', hex: '#9E9E9E' },
      ],
    },
    {
      material: 'PETG-CF',
      colors: [
        { name: 'Antique brass', hex: '#3D2400' },
        { name: 'Black', hex: '#000000' },
        { name: 'Dark Grey', hex: '#1E1E1E' },
        { name: 'Dark Green', hex: '#004000' },
        { name: 'Deep Blue', hex: '#012760' },
      ],
    },
    {
      material: 'ABS',
      colors: [
        { name: 'Green', hex: '#007A3F' },
        { name: 'Yellow', hex: '#EEF769' },
        { name: 'Dark Blue', hex: '#092B44' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Pink', hex: '#FF0066' },
        { name: 'Pine Green', hex: '#3C694F' },
        { name: 'Skin', hex: '#E7B1A5' },
        { name: 'Dark Red', hex: '#8A0A17' },
        { name: 'Blue', hex: '#0161FD' },
        { name: 'Clear', hex: '#CEE1EE' },
        { name: 'Red', hex: '#B32821' },
        { name: 'Gold', hex: '#B99922' },
        { name: 'Peak Green', hex: '#4DA036' },
        { name: 'Black', hex: '#000000' },
        { name: 'Natural', hex: '#CEC5BB' },
        { name: 'Orange', hex: '#E06500' },
        { name: 'Fire Engine Red', hex: '#A5211F' },
        { name: 'Gray', hex: '#2E2E2E' },
        { name: 'Light Blue', hex: '#02A9CB' },
      ],
    },
    {
      material: 'ASA',
      colors: [
        { name: 'Silver', hex: '#838081' },
        { name: 'Red (ASA+175R1P1)', hex: '#FB3328' },
        { name: 'Green', hex: '#007A3F' },
        { name: 'Red', hex: '#B92D5D' },
      ],
    },
    {
      material: 'TPU',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#2243A5' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'TPU 95A',
      colors: [
        { name: 'Trans-Red', hex: '#F00505' },
        { name: 'Transparent Orange', hex: '#EF5205' },
        { name: 'Natural', hex: '#E6E6E6' },
        { name: 'White', hex: '#FFFFFF' },
        { name: 'Translucent Pink', hex: '#E61990' },
        { name: 'Translucent Blue', hex: '#1C90E3' },
        { name: 'Transparent Yellow', hex: '#FFFF3C' },
        { name: 'Clear', hex: '#D4D4D4' },
        { name: 'Translucent Red', hex: '#CC0000' },
        { name: 'Trans - Blue', hex: '#0616F4' },
      ],
    },
    {
      material: 'PA',
      colors: [
        { name: 'Natural - nocolor', hex: '#CCCCCC' },
      ],
    },
    {
      material: 'PA-CF',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PA12',
      colors: [
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PC',
      colors: [
        { name: 'Natural', hex: '#FFFFFF' },
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'HIPS',
      colors: [
        { name: 'Blue', hex: '#002AFF' },
        { name: 'Natural', hex: '#FFFFFF' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'Black', hex: '#000000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
  ],
};

const SLIC3D: ManufacturerCatalog = {
  name: 'Slic3D',
  materials: [
    {
      material: 'PLA Basic',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Grey', hex: '#666666' },
        { name: 'Pink', hex: '#FFB0D8' },
        { name: 'Red', hex: '#C80000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PLA Lite',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
    {
      material: 'PETG Basic',
      colors: [
        { name: 'Black', hex: '#000000' },
        { name: 'Blue', hex: '#022CAC' },
        { name: 'Gray', hex: '#ADAEB1' },
        { name: 'Red', hex: '#FF0000' },
        { name: 'White', hex: '#FFFFFF' },
      ],
    },
    {
      material: 'PETG Lite',
      colors: [
        { name: 'Black', hex: '#000000' },
      ],
    },
  ],
};

export const MANUFACTURER_CATALOGS: ManufacturerCatalog[] = [ELEGOO, OVERTURE, HATCHBOX, _3DHOJOR, ANYCUBIC, BAMBU_LAB, CREALITY, DEEPLEE, ERYONE, FLASHFORGE, GEEETECH, INLAND, KINGROON, MATTERHACKERS, POLYMAKER, PRUSA, PRUSAMENT, SUNLU, ESUN, SLIC3D];

export function getManufacturerNames(): string[] {
  return MANUFACTURER_CATALOGS.map((m) => m.name);
}

export function getMaterialsForManufacturer(manufacturer: string): string[] {
  const catalog = MANUFACTURER_CATALOGS.find((m) => m.name === manufacturer);
  return catalog ? catalog.materials.map((m) => m.material) : [];
}

export function getColorsForMaterial(manufacturer: string, material: string): ManufacturerColor[] {
  const catalog = MANUFACTURER_CATALOGS.find((m) => m.name === manufacturer);
  if (!catalog) return [];
  const mat = catalog.materials.find((m) => m.material === material);
  return mat ? mat.colors : [];
}
